var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _mask2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _mask3, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _mask4, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _mask5, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _mask6, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _rect, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3496,
    height: 2702,
    viewBox: "0 0 3496 2702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_899_2074",
    maskUnits: "userSpaceOnUse",
    x: -13.2426,
    y: 1980.58,
    width: 246.557,
    height: 466.357,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -13.2426,
    y: 1980.58,
    width: 246.557,
    height: 466.357
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.279 2443.77L18.291 2057.61L61.0225 1998.95L78.6558 2050.53L23.5744 2071.24L18.291 2057.61"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.279 2443.77L18.291 2057.61L61.0225 1998.95L78.6558 2050.53L23.5744 2071.24L18.291 2057.61",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.291 2057.61L11.825 2052.9L9.28577 2056.38L10.8015 2060.42L18.291 2057.61ZM61.0225 1998.95L68.5923 1996.36L63.6152 1981.81L54.5564 1994.24L61.0225 1998.95ZM78.6558 2050.53L81.4713 2058.01L88.7367 2055.28L86.2256 2047.94L78.6558 2050.53ZM23.5744 2071.24L16.1154 2074.13L18.9778 2081.51L26.3899 2078.72L23.5744 2071.24ZM170.768 2440.96L25.7806 2054.8L10.8015 2060.42L155.789 2446.58L170.768 2440.96ZM24.7571 2062.32L67.4886 2003.66L54.5564 1994.24L11.825 2052.9L24.7571 2062.32ZM53.4527 2001.54L71.0861 2053.11L86.2256 2047.94L68.5923 1996.36L53.4527 2001.54ZM75.8403 2043.04L20.7589 2063.75L26.3899 2078.72L81.4713 2058.01L75.8403 2043.04ZM31.0335 2068.34L25.7501 2054.72L10.832 2060.5L16.1154 2074.13L31.0335 2068.34Z",
    fill: "#9C9C9C",
    mask: "url(#path-1-outside-1_899_2074)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2988 2100.98L88.9867 2075.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.793 2128.05L99.4808 2102.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5898 2158.48L111.278 2133.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1562 2185.73L121.844 2160.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3613 2212.05L132.049 2186.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9277 2239.31L142.616 2213.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7246 2269.74L154.412 2244.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.293 2297L164.981 2271.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.801 2326.68L176.489 2301.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.367 2353.94L187.055 2328.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.164 2384.37L198.852 2358.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.658 2411.43L209.346 2385.97",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-2_899_2074",
    maskUnits: "userSpaceOnUse",
    x: 150.755,
    y: 2379.49,
    width: 178.761,
    height: 177.049,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 150.755,
    y: 2379.49,
    width: 178.761,
    height: 177.049
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.646 2437.2L218.774 2411.95L259.007 2512.95L294.608 2432.58"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.774 2411.95L226.207 2408.99L223.273 2401.62L215.883 2404.49L218.774 2411.95ZM259.007 2512.95L251.575 2515.91L258.616 2533.59L266.322 2516.19L259.007 2512.95ZM156.538 2444.65L221.666 2419.41L215.883 2404.49L150.755 2429.74L156.538 2444.65ZM211.342 2414.91L251.575 2515.91L266.439 2509.99L226.207 2408.99L211.342 2414.91ZM266.322 2516.19L301.922 2435.82L287.293 2429.34L251.693 2509.71L266.322 2516.19Z",
    fill: "#9C9C9C",
    mask: "url(#path-15-outside-2_899_2074)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 2545.88C119.654 2537.77 119.402 2529.92 119.265 2521.82C119.196 2517.76 119.055 2513.52 119.172 2509.4C119.332 2504.83 121.967 2501.66 126.259 2499.99C130.738 2498.26 135.217 2496.52 139.509 2494.86C143.801 2493.19 147.511 2493.9 150.824 2496.91C152.409 2498.23 153.692 2499.88 155.162 2501.46C162.254 2509.23 169.16 2517.08 176.065 2524.92C176.873 2525.9 177.566 2527.13 177.814 2528.32C178.164 2530.33 176.919 2532.11 175.312 2532.94C173.518 2533.85 171.404 2533.38 169.862 2531.62C166.849 2528.28 163.836 2524.94 160.823 2521.6C157.738 2518.07 154.466 2514.61 151.381 2511.08C151.122 2510.97 150.977 2510.6 150.532 2510.55C151.225 2511.79 152.177 2513.14 152.871 2514.37C157.879 2522.31 162.961 2530.43 167.969 2538.37C169.47 2540.58 168.971 2542.06 166.359 2543.07C165.612 2543.36 164.679 2543.72 163.746 2544.08C163.963 2544.64 164.108 2545.02 164.325 2545.58C168.089 2555.29 171.852 2564.99 175.616 2574.7C176.701 2577.5 176.119 2579.87 173.982 2581.56C171.286 2583.47 167.504 2582.57 165.973 2579.73C165.756 2579.17 165.538 2578.61 165.249 2577.86C161.63 2568.53 157.939 2559.01 154.32 2549.67C154.103 2549.11 153.958 2548.74 153.741 2548.18C152.995 2548.47 152.435 2548.68 151.502 2549.05C151.647 2549.42 151.791 2549.79 152.009 2550.35C155.772 2560.06 159.536 2569.77 163.227 2579.29C164.385 2582.28 163.802 2584.65 161.479 2586.41C158.783 2588.31 154.814 2587.49 153.397 2584.39C153.18 2583.83 152.963 2583.27 152.818 2582.89C149.127 2573.37 145.436 2563.85 141.817 2554.52C141.672 2554.15 141.455 2553.59 141.238 2553.03C140.305 2553.39 139.372 2553.75 138.439 2554.11C136.386 2554.91 134.832 2554.22 134.596 2551.95C133.4 2545.54 132.276 2539.32 131.079 2532.91C130.306 2528.7 129.46 2524.31 128.687 2520.1C128.614 2519.91 128.542 2519.72 128.211 2519.42C128.169 2519.87 128.199 2520.5 128.157 2520.95C128.409 2528.79 128.475 2536.71 128.727 2544.56C128.818 2546.46 128.205 2548.2 126.225 2549.18C124.618 2550.02 123.094 2549.97 121.654 2549.02C121.064 2548.61 120.66 2548.12 120.07 2547.7C120.226 2547 120.009 2546.44 119.792 2545.88Z",
    fill: "#9C9C9C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215.148 2512.78C214.402 2513.07 213.656 2513.35 212.909 2513.64C213.126 2514.2 213.271 2514.58 213.416 2514.95C218.482 2528.02 223.548 2541.09 228.542 2553.97C229.772 2557.14 228.889 2559.85 226.048 2561.38C223.58 2562.76 220.431 2561.84 218.857 2559.44C218.381 2558.77 218.092 2558.02 217.875 2557.46C208.9 2534.31 199.998 2511.35 191.023 2488.2C190.879 2487.83 190.662 2487.27 190.517 2486.89C190.185 2486.59 189.667 2486.36 189.294 2486.51C188.921 2486.65 188.693 2487.17 188.651 2487.62C188.536 2487.88 188.94 2488.36 189.013 2488.55C192.921 2498.63 196.57 2508.6 200.478 2518.68C201.636 2521.67 200.193 2524.59 197.177 2525.11C195.166 2525.46 193.022 2524.36 192.226 2522.31C191.864 2521.37 191.574 2520.63 191.212 2519.69C187.594 2510.36 184.089 2500.77 180.47 2491.43C178.009 2485.08 180.637 2479.13 186.982 2476.67C194.26 2473.85 201.724 2470.95 209.002 2468.13C215.16 2465.74 221.117 2468.37 223.692 2474.46C227.859 2484.66 231.768 2494.74 235.748 2505C236.906 2507.99 235.463 2510.91 232.447 2511.44C230.249 2511.86 228.292 2510.69 227.309 2508.71C226.513 2506.65 225.717 2504.6 224.848 2502.36C221.664 2494.14 218.365 2486.19 215.18 2477.98C215.108 2477.79 214.963 2477.42 214.891 2477.23C214.559 2476.93 214.041 2476.7 213.855 2476.77C213.482 2476.92 213.253 2477.43 213.211 2477.88C213.169 2478.33 213.573 2478.81 213.718 2479.19C222.692 2502.34 231.667 2525.48 240.828 2548.56C241.479 2550.24 241.872 2551.81 241.072 2553.62C240.158 2555.69 238.509 2556.98 236.167 2557.03C233.825 2557.07 232.126 2556.01 231.143 2554.03C230.926 2553.47 230.781 2553.1 230.564 2552.54C225.57 2539.66 220.577 2526.78 215.655 2514.08C215.51 2513.71 215.366 2513.34 215.148 2512.78Z",
    fill: "#9C9C9C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.513 2518.13C171.651 2503.01 165.788 2487.89 159.926 2472.77C158.985 2470.34 159.526 2468.41 161.434 2467.24C163.414 2466.26 165.859 2467.03 166.842 2469.01C166.987 2469.39 167.131 2469.76 167.276 2470.13C178.928 2500.19 190.581 2530.25 202.233 2560.3C203.247 2562.92 202.82 2564.58 200.984 2565.94C198.962 2567.37 196.33 2566.67 195.275 2564.5C195.058 2563.94 194.914 2563.57 194.696 2563.01C189.093 2548 183.303 2533.07 177.513 2518.13Z",
    fill: "#9C9C9C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.903 2477.11C129.755 2475.23 135.193 2477.63 137.075 2482.49C138.957 2487.34 136.558 2492.78 131.706 2494.66C126.854 2496.54 121.156 2494.03 119.275 2489.17C117.652 2484.43 120.051 2478.99 124.903 2477.11Z",
    fill: "#9C9C9C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M197.092 2469.53C192.24 2471.41 186.801 2469.01 184.919 2464.15C183.037 2459.3 185.436 2453.86 190.288 2451.98C195.14 2450.1 200.579 2452.5 202.461 2457.35C204.457 2461.95 201.944 2467.65 197.092 2469.53Z",
    fill: "#9C9C9C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.209 2615.25L255.568 2578.28C270.319 2572.56 277.623 2556 271.903 2541.24L234.919 2445.85C229.2 2431.09 212.639 2423.78 197.888 2429.5L102.529 2466.47C87.7782 2472.19 80.4746 2488.75 86.1941 2503.51L123.178 2598.9C128.897 2613.65 145.458 2620.97 160.209 2615.25Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M430.188 2437.76L430.112 2437.81L430.04 2437.88C429.089 2438.69 427.506 2438.75 426.287 2437.49C419.47 2429.99 407.723 2435.23 407.235 2444.71L407.228 2444.84L407.23 2444.96C407.243 2446.15 406.094 2447.57 404.513 2447.71C394.86 2448.47 390.579 2460.76 398.477 2467.03C399.825 2468.16 399.944 2469.85 399.185 2470.93L399.164 2470.96L399.145 2470.99C393.605 2479.17 400.741 2489.95 410.449 2487.89C411.905 2487.6 413.385 2488.42 413.911 2490.01C416.862 2499.31 429.759 2500.45 434.152 2491.6L434.156 2491.59L434.161 2491.58C434.801 2490.27 436.517 2489.61 437.872 2490.14L437.882 2490.14L437.892 2490.15C447.108 2493.73 455.876 2484.18 451.765 2475.31L451.726 2475.23L451.684 2475.15C451.066 2473.96 451.451 2472.3 452.904 2471.44C461.417 2466.44 459.486 2453.77 450.006 2451.36C448.344 2450.82 447.492 2449.39 447.683 2447.95C449.292 2438 437.836 2431.8 430.188 2437.76Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M506.688 2406.28L506.683 2406.27C499.883 2399.15 487.88 2403.8 487.66 2413.65L487.659 2413.71L487.66 2413.78C487.673 2414.97 486.523 2416.38 484.943 2416.52C475.29 2417.29 471.009 2429.58 478.906 2435.85C480.255 2436.98 480.374 2438.67 479.614 2439.75L479.594 2439.78L479.574 2439.8C474.034 2447.99 481.17 2458.77 490.879 2456.71C492.335 2456.41 493.815 2457.23 494.34 2458.83C497.291 2468.13 510.189 2469.26 514.581 2460.41L514.586 2460.4L514.591 2460.4C515.231 2459.09 516.947 2458.42 518.301 2458.96L518.311 2458.96L518.322 2458.96C527.538 2462.54 536.305 2452.99 532.195 2444.13L532.156 2444.05L532.113 2443.96C531.495 2442.78 531.881 2441.12 533.333 2440.25C541.847 2435.25 539.915 2422.58 530.436 2420.18C528.773 2419.63 527.921 2418.21 528.113 2416.77C529.722 2406.81 518.265 2400.62 510.617 2406.57L510.542 2406.63L510.469 2406.69C509.512 2407.51 507.911 2407.56 506.688 2406.28Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M586.756 2377.06L586.681 2377.12L586.608 2377.18C585.658 2377.99 584.074 2378.05 582.855 2376.79C576.038 2369.29 564.291 2374.53 563.803 2384.01L563.797 2384.14L563.798 2384.27C563.812 2385.45 562.662 2386.87 561.082 2387.01C551.429 2387.77 547.148 2400.06 555.045 2406.33C556.394 2407.46 556.513 2409.15 555.753 2410.23L555.733 2410.26L555.713 2410.29C550.173 2418.47 557.309 2429.25 567.017 2427.2C568.474 2426.9 569.953 2427.72 570.479 2429.31C573.43 2438.61 586.327 2439.75 590.72 2430.9L590.725 2430.89L590.73 2430.88C591.37 2429.57 593.086 2428.91 594.44 2429.44L594.45 2429.44L594.46 2429.45C603.676 2433.03 612.444 2423.48 608.334 2414.61L608.295 2414.53L608.252 2414.45C607.634 2413.26 608.019 2411.6 609.472 2410.74C617.986 2405.74 616.054 2393.07 606.574 2390.66C604.912 2390.12 604.06 2388.69 604.252 2387.25C605.861 2377.3 594.404 2371.1 586.756 2377.06Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M656.922 2349.85L656.847 2349.91L656.774 2349.97C655.824 2350.79 654.24 2350.84 653.021 2349.59C646.204 2342.09 634.457 2347.33 633.969 2356.81L633.963 2356.94L633.964 2357.06C633.977 2358.25 632.828 2359.67 631.248 2359.8C621.595 2360.57 617.314 2372.86 625.211 2379.13C626.56 2380.26 626.679 2381.95 625.919 2383.03L625.899 2383.06L625.879 2383.09C620.339 2391.27 627.475 2402.05 637.183 2399.99C638.64 2399.69 640.119 2400.51 640.645 2402.11C643.596 2411.41 656.493 2412.54 660.886 2403.7L660.891 2403.69L660.896 2403.68C661.536 2402.37 663.252 2401.7 664.606 2402.24L664.616 2402.24L664.626 2402.25C673.842 2405.82 682.61 2396.27 678.5 2387.41L678.461 2387.33L678.418 2387.24C677.8 2386.06 678.185 2384.4 679.638 2383.53C688.152 2378.53 686.22 2365.87 676.74 2363.46C675.078 2362.92 674.226 2361.49 674.418 2360.05C676.027 2350.09 664.57 2343.9 656.922 2349.85Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M739.082 2320.36L739.007 2320.42L738.934 2320.49C737.984 2321.3 736.4 2321.35 735.181 2320.1C728.365 2312.6 716.618 2317.84 716.129 2327.32L716.123 2327.45L716.124 2327.57C716.138 2328.76 714.988 2330.18 713.408 2330.31C703.755 2331.08 699.474 2343.37 707.371 2349.64C708.72 2350.77 708.839 2352.46 708.079 2353.54L708.059 2353.57L708.039 2353.6C702.499 2361.78 709.635 2372.56 719.344 2370.5C720.8 2370.21 722.279 2371.02 722.805 2372.62C725.756 2381.92 738.654 2383.06 743.046 2374.21L743.051 2374.2L743.056 2374.19C743.696 2372.88 745.412 2372.22 746.766 2372.75L746.776 2372.75L746.786 2372.76C756.002 2376.34 764.77 2366.79 760.66 2357.92L760.621 2357.84L760.578 2357.76C759.96 2356.57 760.345 2354.91 761.798 2354.04C770.312 2349.05 768.38 2336.38 758.9 2333.97C757.238 2333.43 756.386 2332 756.578 2330.56C758.187 2320.6 746.73 2314.41 739.082 2320.36Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M820.446 2288.82L820.37 2288.88L820.297 2288.94C819.347 2289.76 817.763 2289.81 816.544 2288.56C809.817 2281.16 797.705 2286.23 797.488 2295.9L797.487 2295.96L797.488 2296.03C797.501 2297.22 796.352 2298.63 794.771 2298.77C785.118 2299.54 780.837 2311.83 788.735 2318.1C790.083 2319.23 790.202 2320.92 789.442 2322L789.422 2322.03L789.402 2322.05C783.862 2330.24 790.998 2341.02 800.707 2338.96C802.163 2338.66 803.643 2339.48 804.168 2341.08C807.12 2350.38 820.017 2351.51 824.409 2342.66L824.414 2342.65L824.419 2342.64C825.059 2341.34 826.775 2340.67 828.129 2341.21L828.14 2341.21L828.15 2341.21C837.366 2344.79 846.133 2335.24 842.023 2326.38L841.984 2326.3L841.942 2326.21C841.324 2325.03 841.709 2323.37 843.161 2322.5C851.675 2317.5 849.743 2304.83 840.264 2302.43C838.601 2301.88 837.749 2300.46 837.941 2299.02C839.55 2289.06 828.093 2282.87 820.446 2288.82Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M901.584 2253.93L901.508 2253.99L901.436 2254.05C900.489 2254.86 898.912 2254.92 897.694 2253.67C890.804 2245.95 879.007 2251.23 878.629 2260.94L878.625 2261.04L878.626 2261.14C878.639 2262.32 877.49 2263.74 875.909 2263.88C866.257 2264.64 861.975 2276.93 869.873 2283.2C871.221 2284.33 871.34 2286.02 870.581 2287.1L870.56 2287.13L870.541 2287.16C865.001 2295.34 872.137 2306.12 881.845 2304.07C883.301 2303.77 884.781 2304.59 885.307 2306.18C888.258 2315.48 901.155 2316.62 905.548 2307.77L905.552 2307.76L905.557 2307.75C906.197 2306.44 907.913 2305.78 909.268 2306.31L909.278 2306.32L909.288 2306.32C918.504 2309.9 927.272 2300.35 923.161 2291.48L923.123 2291.4L923.08 2291.32C922.462 2290.13 922.847 2288.47 924.3 2287.61C932.813 2282.61 930.882 2269.94 921.402 2267.54C919.74 2266.99 918.888 2265.57 919.079 2264.12C920.688 2254.17 909.232 2247.97 901.584 2253.93Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M967.611 2228.66L967.607 2228.65C960.807 2221.53 948.804 2226.18 948.584 2236.03L948.583 2236.1L948.583 2236.16C948.597 2237.35 947.447 2238.77 945.867 2238.9C936.214 2239.67 931.933 2251.96 939.83 2258.23C941.179 2259.36 941.298 2261.05 940.538 2262.13L940.518 2262.16L940.498 2262.19C934.958 2270.37 942.094 2281.15 951.803 2279.09C953.259 2278.8 954.738 2279.61 955.264 2281.21C958.215 2290.51 971.113 2291.65 975.505 2282.8L975.51 2282.79L975.515 2282.78C976.155 2281.47 977.871 2280.81 979.225 2281.34L979.235 2281.34L979.245 2281.35C988.461 2284.93 997.229 2275.38 993.119 2266.51L993.08 2266.43L993.037 2266.35C992.419 2265.16 992.804 2263.5 994.257 2262.63C1002.77 2257.64 1000.84 2244.97 991.359 2242.56C989.697 2242.02 988.845 2240.59 989.037 2239.15C990.646 2229.19 979.189 2223 971.541 2228.95L971.466 2229.01L971.393 2229.08C970.436 2229.9 968.834 2229.95 967.611 2228.66Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.24 1229.63L1021.91 1180.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.28 1212.84L1042.23 1156.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.21 1196.3L1067.09 1139.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.09 1176.69L1089.97 1119.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.54 1160.94L1118.42 1104.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.4 1139.07L1145.16 1088.38",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.06 1123.32L1166.22 1065.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.89 1049.44L1224.73 1107.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.23 1089.01L1215.39 1030.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.49 1074.23L1244.46 1016.17",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.48 975.321L1400.24 924.637",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1454.14 959.575L1421.3 901.441",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1803.16 730.853L1774.93 680.168",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.38 715.062L1795.8 657.043",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1853.49 699.533L1821.09 641.441",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1876.73 680.859L1844.15 622.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1905.43 666.296L1872.85 608.277",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2435.75 344.306L2412.59 291.223",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2462.35 330.986L2435.34 270.164",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2489.03 317.852L2461.94 256.844",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2513.77 301.388L2486.76 240.566",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2543.63 289.811L2516.73 228.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2568.11 273.234L2544.77 220.223",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2594.61 260.171L2567.71 199.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2621.21 246.851L2594.38 185.957",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2646.03 230.573L2619.12 169.492",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2676 218.738L2649.17 157.844",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.88 1165.29L1318.18 1167.55C1314.88 1165.29 1314.88 1165.29 1314.88 1165.29L1314.87 1165.29L1314.87 1165.3L1314.85 1165.33L1314.79 1165.42C1314.74 1165.5 1314.66 1165.61 1314.57 1165.75C1314.38 1166.04 1314.11 1166.45 1313.79 1166.96C1313.14 1168 1312.25 1169.47 1311.28 1171.22C1309.36 1174.7 1307.03 1179.48 1305.67 1184.35C1304.36 1189.02 1303.65 1194.79 1306.3 1199.49C1309.19 1204.61 1315.04 1206.87 1323.1 1206.62C1327.26 1206.49 1333.12 1205.33 1339.93 1203.56C1346.83 1201.77 1354.99 1199.27 1363.9 1196.32C1381.7 1190.42 1402.63 1182.65 1422.59 1174.92C1442.56 1167.19 1461.61 1159.5 1475.65 1153.73C1482.68 1150.85 1488.46 1148.45 1492.48 1146.77C1494.49 1145.93 1496.06 1145.27 1497.13 1144.82C1497.42 1144.7 1497.67 1144.59 1497.88 1144.5C1498.06 1144.42 1498.22 1144.36 1498.35 1144.3L1498.67 1144.17L1498.75 1144.14L1498.77 1144.13L1498.77 1144.13C1498.77 1144.13 1498.77 1144.13 1497.21 1140.44L1498.77 1144.13L1502.26 1142.65L1500.98 1139.09L1479.46 1079.41L1728.02 979.875L1731.62 978.436L1730.3 974.799L1705.66 906.827L1703.91 902.002L1699.66 904.876L1315.94 1164.23L1315.31 1164.66L1314.88 1165.29Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M495.141 1722.85C491.592 1721 491.591 1721 491.591 1721.01L491.589 1721.01L491.585 1721.02L491.572 1721.04L491.529 1721.13C491.492 1721.2 491.442 1721.3 491.378 1721.43C491.252 1721.68 491.074 1722.05 490.859 1722.51C490.429 1723.43 489.846 1724.74 489.222 1726.31C487.988 1729.42 486.536 1733.7 485.842 1738.13C485.165 1742.44 485.101 1747.54 487.348 1751.81C489.788 1756.46 494.45 1759.23 501.179 1759.63C504.602 1759.83 509.21 1759.13 514.352 1757.97C519.592 1756.79 525.741 1755.04 532.398 1752.93C545.717 1748.71 561.287 1742.98 576.092 1737.23C590.908 1731.47 605.008 1725.67 615.401 1721.32C620.599 1719.14 624.872 1717.32 627.846 1716.05C629.334 1715.41 630.497 1714.91 631.289 1714.56C631.685 1714.39 631.988 1714.26 632.193 1714.17L632.425 1714.07L632.485 1714.05L632.5 1714.04L632.504 1714.04C632.505 1714.04 632.506 1714.04 630.907 1710.37L632.506 1714.04L635.959 1712.53L634.663 1708.99L613.976 1652.52L860.583 1557.54L864.096 1556.19L862.959 1552.6L841.805 1485.86L840.174 1480.71L835.725 1483.77L492.875 1719.55L492.052 1720.12L491.592 1721L495.141 1722.85Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2453.65 615.896L2449.63 617.247L2451.21 621.182L2502.61 748.783L2513.09 774.784L2510.31 746.892L2496.32 606.718L2495.82 601.725L2491.06 603.323L2453.65 615.896Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2480.05 846.82L2476.06 848.182L2477.63 852.095L2528.77 979.582L2539.26 1005.73L2536.46 977.695L2522.47 837.522L2521.97 832.504L2517.2 834.133L2480.05 846.82Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2507.18 1079.61L2503.19 1080.97L2504.76 1084.88L2555.98 1212.55L2566.48 1238.74L2563.67 1210.67L2549.61 1070.31L2549.11 1065.29L2544.34 1066.92L2507.18 1079.61Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2526.64 1310.86L2522.65 1312.22L2524.22 1316.13L2575.36 1443.62L2585.85 1469.77L2583.06 1441.73L2569.07 1301.56L2568.57 1296.54L2563.8 1298.17L2526.64 1310.86Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.54 976.164L2480.98 686.897",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.16 1385.66L1166.46 1515.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.9 1395.07L1142.21 1524.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.81 1407.52L1110.11 1537.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.36 1416.99L1085.66 1546.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M2120.79 991.457L2171.09 1121.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.34 1000.94L2146.64 1130.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M2064.25 1013.38L2114.55 1143.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M2039.99 1022.79L2090.29 1152.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.82 1123.98L1502.73 1064.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1554.93 1112.7L1531.85 1053.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1582.37 1102.06L1559.28 1042.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1612.78 1090.27L1589.7 1030.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M739.514 1672.13L716.426 1612.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M768.437 1660.92L745.35 1601.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M796.056 1650.21L772.969 1590.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M826.474 1638.42L803.387 1578.86",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M632.908 1711.1L609.82 1651.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M662.019 1699.81L638.932 1640.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M689.451 1689.18L666.363 1629.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M719.869 1677.38L696.781 1617.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1640.22 1079.63L1617.13 1020.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1669.33 1068.35L1646.24 1008.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1696.76 1057.71L1673.67 998.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M859.145 1553.81L2507.17 917.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M300.721 2014.25L2537.52 1149.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M247.2 2039.94L325.71 2009.5L329.44 2008.05L327.994 2004.32L302.373 1938.24L299.788 1931.57L295.459 1937.26L197.082 2066.67L197.056 2066.7L197.03 2066.74L200.267 2069.09C197.03 2066.74 197.029 2066.74 197.027 2066.74L197.025 2066.75L197.018 2066.75L196.998 2066.78C196.981 2066.81 196.96 2066.84 196.933 2066.87C196.878 2066.95 196.803 2067.06 196.71 2067.2C196.523 2067.47 196.262 2067.86 195.946 2068.35C195.316 2069.33 194.464 2070.74 193.554 2072.45C191.751 2075.84 189.631 2080.61 188.628 2085.82C187.625 2091.02 187.674 2097.03 190.687 2102.54C193.741 2108.11 199.46 2112.48 208.407 2115.08C225.944 2120.18 241.256 2117.03 252.099 2112.66C257.518 2110.47 261.852 2107.97 264.844 2106.01C266.343 2105.02 267.51 2104.17 268.316 2103.55C268.72 2103.24 269.033 2102.99 269.252 2102.81C269.362 2102.72 269.448 2102.65 269.51 2102.6C269.521 2102.59 269.532 2102.58 269.541 2102.57C269.559 2102.56 269.573 2102.54 269.585 2102.53L269.61 2102.51L269.618 2102.5L269.622 2102.5C269.623 2102.5 269.625 2102.5 267.002 2099.48L269.625 2102.5L271.782 2100.63L270.709 2097.98L247.2 2039.94Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.49 1376.09L1839.79 1505.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.39 1388.53L1807.7 1518.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1732.95 1398.01L1783.25 1527.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1841.75 1504.39L1811.99 1431.39L2143.94 1303.55L2172.68 1378.05L1841.75 1504.39Z",
    fill: "#6CDD59"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1813.94 1366.61L1864.24 1496.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.38 1405.91L1750.68 1535.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.93 1415.39L1726.23 1545.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1644.02 1427.76L1694.32 1557.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1619.57 1437.24L1669.88 1566.98",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.67 1324.07L1973.97 1453.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1899.22 1333.55L1949.52 1463.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1867.31 1345.92L1917.61 1475.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.86 1355.4L1893.16 1485.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M912.898 1705.2L963.199 1834.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M888.453 1714.68L938.754 1844.42",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M856.543 1727.05L906.844 1856.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M832.096 1736.52L882.397 1866.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M665.164 1796.52L715.465 1926.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M633.252 1808.89L683.553 1938.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M608.807 1818.36L659.107 1948.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M635.729 1882.27L610.956 1817.4L631.229 1809.47L655.495 1874.33L635.729 1882.27Z",
    fill: "#6CDD59"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M689.609 1787.04L739.91 1916.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M537.812 2093.7L588.113 2223.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M518.219 2101.3L568.52 2231.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M486.121 2113.74L536.422 2243.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M461.861 2123.14L512.162 2252.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M432.748 2134.43L483.049 2264.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M408.488 2143.84L458.789 2273.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M376.393 2156.28L426.693 2286.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M351.945 2165.76L402.246 2295.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M319.375 2173.66L369.676 2303.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M294.93 2183.14L345.23 2312.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M263.02 2195.51L313.32 2325.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M238.572 2204.99L288.873 2334.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M443.193 1887.29L493.494 2017.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M411.098 1899.73L461.398 2029.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M386.65 1909.21L436.951 2038.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M436.558 1959.07L413.775 1898.76L441.139 1888.36L464.433 1948.16L436.558 1959.07Z",
    fill: "#EEEEEE"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M495.754 2015.61L471.482 1951.25L633.665 1887.81L658.941 1952.68L495.754 2015.61Z",
    fill: "#6CDD59"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M467.453 1877.89L517.754 2007.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M577.369 1835.27L627.67 1965.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M552.924 1844.75L603.225 1974.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M521.014 1857.12L571.314 1986.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M496.566 1866.6L546.867 1996.35",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M354.08 1917.12L404.381 2046.86",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M329.635 1926.59L379.936 2056.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M297.725 1938.96L348.025 2068.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M299.043 2014.9L323.578 2078.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M266.572 2027.49L291.107 2090.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M350.329 2068.07L327.529 2009.78L330.568 2008.8L329.581 2005.76L353.911 1995.84L377.703 2056.66L350.329 2068.07Z",
    fill: "#FF1717"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M976.986 1771.39L978.106 1770.96C988.378 1766.98 993.511 1755.33 989.529 1745.06C985.546 1734.79 973.906 1729.65 963.634 1733.63L962.514 1734.06C952.242 1738.05 947.109 1749.69 951.092 1759.96C955.074 1770.24 966.714 1775.38 976.986 1771.39Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M2373.54 1232.55L2374.65 1232.12C2384.9 1228.14 2390.14 1216.71 2386.08 1206.22C2382.09 1195.94 2370.45 1190.8 2360.18 1194.79L2359.06 1195.22C2348.79 1199.2 2343.66 1210.85 2347.64 1221.12C2351.62 1231.39 2363.26 1236.53 2373.54 1232.55Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M263.678 2256.46L277.3 2251.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M255.892 2226.41L252.162 2227.86L253.608 2231.59L258.892 2245.21L260.338 2248.94L264.067 2247.5L273.584 2243.81L277.314 2242.36L275.868 2238.63L270.585 2225.01L269.139 2221.28L265.409 2222.72L255.892 2226.41Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M272.178 2254.02L268.27 2243.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M321.342 2234.1L334.965 2228.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M313.556 2204.06L309.827 2205.5L311.272 2209.23L316.556 2222.86L318.002 2226.59L321.731 2225.14L331.249 2221.45L334.978 2220.01L333.532 2216.28L328.249 2202.65L326.803 2198.92L323.073 2200.37L313.556 2204.06Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M329.842 2231.67L325.934 2221.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M348.4 2223.61L362.023 2218.33",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M340.615 2193.57L336.885 2195.01L338.331 2198.74L343.614 2212.37L345.06 2216.1L348.79 2214.65L358.307 2210.96L362.037 2209.52L360.591 2205.79L355.307 2192.16L353.861 2188.43L350.132 2189.88L340.615 2193.57Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M356.9 2221.18L352.992 2211.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M403.266 2202.34L416.888 2197.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M395.665 2172.22L391.936 2173.67L393.382 2177.4L398.665 2191.03L400.111 2194.76L403.841 2193.31L413.358 2189.62L417.087 2188.17L415.642 2184.45L410.358 2170.82L408.912 2167.09L405.183 2168.53L395.665 2172.22Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M411.766 2199.91L407.857 2189.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M432.562 2190.98L445.999 2185.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M424.777 2160.94L421.047 2162.38L422.493 2166.11L427.777 2179.74L429.222 2183.47L432.952 2182.03L442.469 2178.34L446.199 2176.89L444.753 2173.16L439.469 2159.53L438.024 2155.8L434.294 2157.25L424.777 2160.94Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M440.875 2188.62L436.967 2178.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M485.375 2170.51L498.998 2165.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M477.589 2140.46L473.86 2141.91L475.306 2145.64L480.589 2159.27L482.035 2162.99L485.764 2161.55L495.282 2157.86L499.011 2156.41L497.565 2152.68L492.282 2139.06L490.836 2135.33L487.107 2136.77L477.589 2140.46Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M493.875 2168.07L489.967 2157.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M514.486 2159.22L528.109 2153.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M506.701 2129.18L502.971 2130.62L504.417 2134.35L509.7 2147.98L511.146 2151.71L514.876 2150.26L524.393 2146.57L528.123 2145.13L526.677 2141.4L521.393 2127.77L519.947 2124.04L516.218 2125.49L506.701 2129.18Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M522.986 2156.79L519.078 2146.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M564.686 2139.76L578.308 2134.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M556.9 2109.72L553.17 2111.16L554.616 2114.89L559.9 2128.52L561.345 2132.25L565.075 2130.8L574.592 2127.11L578.322 2125.67L576.876 2121.94L571.593 2108.31L570.147 2104.58L566.417 2106.03L556.9 2109.72Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M573.186 2137.33L569.277 2127.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M590.438 2129.78L604.06 2124.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M582.652 2099.73L578.922 2101.18L580.368 2104.91L585.652 2118.53L587.097 2122.26L590.827 2120.82L600.344 2117.13L604.074 2115.68L602.628 2111.95L597.344 2098.33L595.899 2094.6L592.169 2096.04L582.652 2099.73Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M598.938 2127.34L595.029 2117.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M630.373 2114.29L643.996 2109.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M622.773 2084.17L619.043 2085.62L620.489 2089.35L625.773 2102.98L627.218 2106.71L630.948 2105.26L640.465 2101.57L644.195 2100.12L642.749 2096.39L637.466 2082.77L636.02 2079.04L632.29 2080.48L622.773 2084.17Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M638.873 2111.86L634.965 2101.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M660.471 2101.12L673.907 2095.91",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M652.685 2071.08L648.955 2072.52L650.401 2076.25L655.685 2089.88L657.131 2093.61L660.86 2092.16L670.377 2088.47L674.107 2087.03L672.661 2083.3L667.378 2069.67L665.932 2065.94L662.202 2067.39L652.685 2071.08Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 2098.76L664.803 2088.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M704.27 2085.64L717.892 2080.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M696.486 2055.6L692.756 2057.04L694.202 2060.77L699.485 2074.4L700.931 2078.13L704.661 2076.69L714.178 2073L717.908 2071.55L716.462 2067.82L711.178 2054.19L709.733 2050.46L706.003 2051.91L696.486 2055.6Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M712.772 2083.21L708.863 2073.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M271.711 2277.18L285.334 2271.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M278.113 2283.72L274.383 2285.17L275.829 2288.9L281.112 2302.52L282.558 2306.25L286.288 2304.81L295.805 2301.12L299.535 2299.67L298.089 2295.94L292.805 2282.31L291.36 2278.58L287.63 2280.03L278.113 2283.72Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M279.705 2273.43L283.613 2283.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M329.373 2254.82L342.996 2249.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M335.773 2261.36L332.043 2262.81L333.489 2266.54L338.773 2280.17L340.218 2283.9L343.948 2282.45L353.465 2278.76L357.195 2277.32L355.749 2273.59L350.466 2259.96L349.02 2256.23L345.29 2257.67L335.773 2261.36Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M337.367 2251.08L341.275 2261.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M356.434 2244.33L370.056 2239.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M362.833 2250.88L359.104 2252.32L360.55 2256.05L365.833 2269.68L367.279 2273.41L371.009 2271.96L380.526 2268.27L384.255 2266.83L382.809 2263.1L377.526 2249.47L376.08 2245.74L372.351 2247.19L362.833 2250.88Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M364.428 2240.59L368.336 2250.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M411.297 2223.06L424.92 2217.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M417.884 2229.54L414.155 2230.98L415.601 2234.71L420.884 2248.34L422.33 2252.07L426.059 2250.62L435.577 2246.93L439.306 2245.49L437.86 2241.76L432.577 2228.13L431.131 2224.4L427.401 2225.85L417.884 2229.54Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M419.291 2219.32L423.199 2229.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M440.596 2211.7L454.032 2206.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M446.997 2218.25L443.268 2219.69L444.714 2223.42L449.997 2237.05L451.443 2240.78L455.173 2239.33L464.69 2235.64L468.419 2234.2L466.974 2230.47L461.69 2216.84L460.244 2213.11L456.515 2214.56L446.997 2218.25Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M448.404 2208.04L452.313 2218.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M493.406 2191.23L507.029 2185.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M499.806 2197.77L496.077 2199.22L497.522 2202.95L502.806 2216.58L504.252 2220.31L507.981 2218.86L517.499 2215.17L521.228 2213.73L519.782 2210L514.499 2196.37L513.053 2192.64L509.323 2194.08L499.806 2197.77Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M501.4 2187.49L505.309 2197.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M522.518 2179.94L536.14 2174.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M528.919 2186.49L525.19 2187.93L526.636 2191.66L531.919 2205.29L533.365 2209.02L537.095 2207.57L546.612 2203.88L550.341 2202.44L548.895 2198.71L543.612 2185.08L542.166 2181.35L538.437 2182.8L528.919 2186.49Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M530.512 2176.2L534.42 2186.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M572.717 2160.48L586.34 2155.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M579.119 2167.02L575.389 2168.47L576.835 2172.2L582.118 2185.83L583.564 2189.56L587.294 2188.11L596.811 2184.42L600.541 2182.98L599.095 2179.25L593.811 2165.62L592.365 2161.89L588.636 2163.33L579.119 2167.02Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M580.711 2156.74L584.619 2166.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M598.471 2150.5L612.093 2145.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M604.872 2157.04L601.143 2158.49L602.589 2162.22L607.872 2175.84L609.318 2179.57L613.048 2178.13L622.565 2174.44L626.294 2172.99L624.849 2169.26L619.565 2155.63L618.119 2151.9L614.39 2153.35L604.872 2157.04Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M606.465 2146.75L610.373 2156.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M638.404 2135.02L652.027 2129.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M644.992 2141.49L641.262 2142.94L642.708 2146.66L647.991 2160.29L649.437 2164.02L653.167 2162.58L662.684 2158.89L666.414 2157.44L664.968 2153.71L659.684 2140.08L658.238 2136.35L654.509 2137.8L644.992 2141.49Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M646.398 2131.27L650.307 2141.35",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M669.588 2124.64L683.024 2119.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M675.915 2131L672.186 2132.45L673.632 2136.18L678.915 2149.8L680.361 2153.53L684.091 2152.09L693.608 2148.4L697.337 2146.95L695.892 2143.22L690.608 2129.59L689.162 2125.87L685.433 2127.31L675.915 2131Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M677.322 2120.79L681.231 2130.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M712.305 2106.36L725.927 2101.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M718.704 2112.91L714.975 2114.35L716.421 2118.08L721.704 2131.71L723.15 2135.44L726.88 2133.99L736.397 2130.3L740.126 2128.86L738.681 2125.13L733.397 2111.5L731.951 2107.77L728.222 2109.22L718.704 2112.91Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M720.299 2102.62L724.207 2112.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M265.126 2193.2L261.397 2194.64L262.843 2198.37L311.407 2323.64L312.852 2327.37L316.582 2325.92L343.641 2315.43L347.37 2313.98L345.924 2310.25L297.361 2184.99L295.915 2181.26L292.185 2182.71L265.126 2193.2Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M352.22 2160.93L348.491 2162.38L349.936 2166.11L399.441 2293.8L400.887 2297.53L404.617 2296.08L424.957 2288.2L428.687 2286.75L427.241 2283.02L377.736 2155.33L376.291 2151.6L372.561 2153.04L352.22 2160.93Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M431.158 2130.33L427.428 2131.77L428.874 2135.5L478.379 2263.2L479.825 2266.93L483.554 2265.48L511.919 2254.48L515.649 2253.04L514.203 2249.31L464.698 2121.62L463.252 2117.89L459.523 2119.33L431.158 2130.33Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M517.56 2096.83L513.83 2098.28L515.276 2102.01L564.781 2229.7L566.227 2233.43L569.956 2231.98L587.685 2225.11L591.414 2223.67L589.968 2219.94L540.464 2092.24L539.018 2088.51L535.288 2089.96L517.56 2096.83Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M588.88 2065.96L585.151 2067.41L586.597 2071.14L636.101 2198.83L637.547 2202.56L641.277 2201.11L659.005 2194.24L662.734 2192.79L661.289 2189.06L611.784 2061.37L610.338 2057.64L606.609 2059.09L588.88 2065.96Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M742.592 1916.94L718.305 1854.6L855.139 1802.08L879.922 1865.43L742.592 1916.94Z",
    fill: "#6CDD59"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M660.601 2039.45L656.871 2040.89L658.317 2044.62L707.822 2172.31L709.268 2176.04L712.997 2174.6L730.726 2167.72L734.455 2166.28L733.009 2162.55L683.505 2034.86L682.059 2031.13L678.329 2032.57L660.601 2039.45Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M333.478 2472.49L329.748 2473.94L331.194 2477.66L341.978 2505.48L343.424 2509.21L347.154 2507.76L2749.61 1576.36L2753.34 1574.92L2751.89 1571.19L2741.11 1543.37L2739.66 1539.64L2735.94 1541.09L333.478 2472.49Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M318.619 2421.98L376.592 2571.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M349.795 2408.82L407.767 2558.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M597.467 2305.71L655.439 2455.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M937.215 2177.65L995.187 2327.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M965.766 2166.58L1023.74 2316.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M992.266 2156.31L1024.98 2240.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M340.332 2456.95L353.768 2451.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M332.546 2426.9L328.817 2428.35L330.263 2432.07L335.546 2445.7L336.992 2449.43L340.721 2447.99L350.239 2444.3L353.968 2442.85L352.522 2439.12L347.239 2425.49L345.793 2421.76L342.064 2423.21L332.546 2426.9Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M348.645 2454.58L344.664 2444.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M396.887 2433.95L410.509 2428.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M389.029 2403.71L385.299 2405.16L386.745 2408.89L392.029 2422.52L393.474 2426.24L397.204 2424.8L406.721 2421.11L410.451 2419.66L409.005 2415.93L403.721 2402.31L402.276 2398.58L398.546 2400.02L389.029 2403.71Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M405.127 2431.39L401.219 2421.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M427.305 2422.15L440.927 2416.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M419.447 2391.92L415.717 2393.36L417.163 2397.09L422.446 2410.72L423.892 2414.45L427.622 2413.01L437.139 2409.32L440.869 2407.87L439.423 2404.14L434.139 2390.51L432.693 2386.78L428.964 2388.23L419.447 2391.92Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M435.733 2419.53L431.824 2409.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M472.453 2405.72L486.076 2400.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M464.667 2375.68L460.938 2377.12L462.384 2380.85L467.667 2394.48L469.113 2398.21L472.843 2396.76L482.36 2393.07L486.089 2391.63L484.643 2387.9L479.36 2374.27L477.914 2370.54L474.185 2371.99L464.667 2375.68Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M480.953 2403.29L476.973 2393.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M497.832 2395.88L511.455 2390.6",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M490.046 2365.84L486.317 2367.28L487.763 2371.01L493.046 2384.64L494.492 2388.37L498.221 2386.92L507.739 2383.23L511.468 2381.79L510.022 2378.06L504.739 2364.43L503.293 2360.7L499.564 2362.15L490.046 2365.84Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M506.332 2393.45L502.352 2383.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M542.395 2375.17L556.017 2369.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M534.722 2344.86L530.993 2346.31L532.438 2350.04L537.722 2363.67L539.168 2367.4L542.897 2365.95L552.415 2362.26L556.144 2360.82L554.698 2357.09L549.415 2343.46L547.969 2339.73L544.239 2341.17L534.722 2344.86Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M550.822 2372.55L546.914 2362.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M572.066 2363.67L585.503 2358.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M564.208 2333.44L560.479 2334.88L561.925 2338.61L567.208 2352.24L568.654 2355.97L572.384 2354.53L581.901 2350.84L585.63 2349.39L584.184 2345.66L578.901 2332.03L577.455 2328.3L573.726 2329.75L564.208 2333.44Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M580.307 2361.12L576.398 2351.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M618.721 2345.58L632.343 2340.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M610.863 2315.35L607.133 2316.79L608.579 2320.52L613.862 2334.15L615.308 2337.88L619.038 2336.44L628.555 2332.75L632.285 2331.3L630.839 2327.57L625.555 2313.94L624.11 2310.21L620.38 2311.66L610.863 2315.35Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M627.148 2342.96L623.24 2332.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M642.191 2336.91L655.814 2331.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M634.519 2306.6L630.789 2308.05L632.235 2311.78L637.519 2325.41L638.965 2329.14L642.694 2327.69L652.211 2324L655.941 2322.55L654.495 2318.82L649.212 2305.2L647.766 2301.47L644.036 2302.91L634.519 2306.6Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M650.619 2334.29L646.711 2324.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M689.717 2317.2L703.153 2311.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M681.931 2287.15L678.202 2288.6L679.647 2292.32L684.931 2305.95L686.377 2309.68L690.106 2308.24L699.624 2304.55L703.353 2303.1L701.907 2299.37L696.624 2285.74L695.178 2282.01L691.448 2283.46L681.931 2287.15Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M698.029 2314.83L694.049 2304.56",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M715.096 2307.36L728.532 2302.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M707.31 2277.31L703.58 2278.76L705.026 2282.48L710.31 2296.11L711.756 2299.84L715.485 2298.4L725.002 2294.71L728.732 2293.26L727.286 2289.53L722.003 2275.9L720.557 2272.17L716.827 2273.62L707.31 2277.31Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M723.408 2304.99L719.428 2294.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M765.355 2289.16L778.792 2283.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M757.497 2258.93L753.768 2260.38L755.214 2264.11L760.497 2277.73L761.943 2281.46L765.673 2280.02L775.19 2276.33L778.919 2274.88L777.474 2271.15L772.19 2257.52L770.744 2253.8L767.015 2255.24L757.497 2258.93Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M773.596 2286.61L769.688 2276.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M348.349 2405.09L344.62 2406.54L346.065 2410.27L366.186 2462.17L367.632 2465.9L371.361 2464.45L395.807 2454.97L399.537 2453.53L398.091 2449.8L377.971 2397.9L376.525 2394.17L372.795 2395.62L348.349 2405.09Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M433.632 2372.03L429.903 2373.48L431.349 2377.21L451.469 2429.11L452.915 2432.84L456.644 2431.39L474.186 2424.59L477.915 2423.14L476.47 2419.41L456.349 2367.52L454.903 2363.79L451.174 2365.23L433.632 2372.03Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M504.917 2344.4L501.188 2345.84L502.634 2349.57L522.754 2401.47L524.2 2405.2L527.929 2403.75L545.471 2396.95L549.201 2395.51L547.755 2391.78L527.634 2339.88L526.189 2336.15L522.459 2337.59L504.917 2344.4Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M581.38 2312.39L577.651 2313.84L579.097 2317.57L599.217 2369.47L600.663 2373.19L604.392 2371.75L621.934 2364.95L625.664 2363.5L624.218 2359.77L604.097 2307.87L602.651 2304.15L598.922 2305.59L581.38 2312.39Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M650.064 2284.69L646.334 2286.13L647.78 2289.86L667.901 2341.76L669.346 2345.49L673.076 2344.05L690.618 2337.25L694.347 2335.8L692.901 2332.07L672.781 2280.17L671.335 2276.44L667.606 2277.89L650.064 2284.69Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M726.388 2255.1L722.659 2256.54L724.104 2260.27L744.225 2312.17L745.671 2315.9L749.4 2314.46L766.942 2307.66L770.671 2306.21L769.225 2302.48L749.105 2250.58L747.659 2246.85L743.93 2248.3L726.388 2255.1Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.49 2158.66L1005.76 2160.1L1007.2 2163.83L1017.84 2191.28L1019.29 2195L1023.02 2193.56L1125.28 2153.91L1129.01 2152.47L1127.57 2148.74L1116.93 2121.29L1115.48 2117.56L1111.75 2119.01L1009.49 2158.66Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.48 2148.29C1059.28 2147.9 1058.96 2147.67 1058.54 2147.57C1058.11 2147.48 1057.65 2147.53 1057.16 2147.72C1056.8 2147.86 1056.51 2148.04 1056.28 2148.27C1056.06 2148.49 1055.91 2148.73 1055.84 2148.99C1055.77 2149.25 1055.79 2149.51 1055.89 2149.77C1055.97 2149.99 1056.1 2150.16 1056.26 2150.27C1056.43 2150.38 1056.61 2150.46 1056.82 2150.5C1057.02 2150.54 1057.22 2150.55 1057.43 2150.55C1057.63 2150.54 1057.82 2150.53 1057.99 2150.51L1058.9 2150.41C1059.13 2150.39 1059.4 2150.37 1059.69 2150.37C1060 2150.37 1060.3 2150.4 1060.6 2150.48C1060.91 2150.55 1061.19 2150.69 1061.45 2150.89C1061.7 2151.1 1061.91 2151.39 1062.06 2151.77C1062.23 2152.21 1062.26 2152.65 1062.17 2153.09C1062.08 2153.54 1061.86 2153.95 1061.5 2154.33C1061.14 2154.71 1060.65 2155.02 1060.03 2155.26C1059.44 2155.49 1058.9 2155.59 1058.4 2155.56C1057.91 2155.54 1057.47 2155.41 1057.1 2155.17C1056.73 2154.92 1056.44 2154.59 1056.23 2154.15L1057.25 2153.76C1057.4 2154.06 1057.6 2154.27 1057.86 2154.4C1058.12 2154.53 1058.4 2154.59 1058.72 2154.58C1059.04 2154.56 1059.36 2154.5 1059.68 2154.37C1060.06 2154.22 1060.37 2154.03 1060.62 2153.79C1060.88 2153.55 1061.05 2153.29 1061.14 2153C1061.22 2152.71 1061.21 2152.42 1061.1 2152.12C1060.99 2151.85 1060.83 2151.66 1060.61 2151.55C1060.4 2151.44 1060.14 2151.38 1059.86 2151.37C1059.57 2151.36 1059.27 2151.37 1058.95 2151.4L1057.84 2151.5C1057.13 2151.57 1056.53 2151.5 1056.03 2151.3C1055.52 2151.11 1055.17 2150.74 1054.95 2150.19C1054.78 2149.73 1054.75 2149.29 1054.86 2148.85C1054.98 2148.42 1055.21 2148.02 1055.55 2147.67C1055.9 2147.32 1056.33 2147.04 1056.85 2146.84C1057.38 2146.63 1057.88 2146.55 1058.36 2146.58C1058.84 2146.6 1059.26 2146.73 1059.63 2146.96C1059.99 2147.19 1060.26 2147.51 1060.43 2147.92L1059.48 2148.29ZM1064.87 2153.22L1063.83 2153.62L1063.67 2144.32L1064.68 2143.93L1070.83 2150.91L1069.79 2151.31L1064.71 2145.4L1064.64 2145.43L1064.87 2153.22ZM1064.02 2149.89L1068.18 2148.28L1068.52 2149.15L1064.35 2150.77L1064.02 2149.89ZM1067.88 2143.7L1067.54 2142.82L1073.65 2140.46L1073.98 2141.33L1071.43 2142.32L1074.24 2149.58L1073.26 2149.97L1070.44 2142.7L1067.88 2143.7Z",
    fill: "#9C9C9C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.36 2112.57L1124.63 2114.02L1126.08 2117.75L1136.72 2145.19L1138.16 2148.92L1141.89 2147.47L1244.16 2107.83L1247.89 2106.38L1246.44 2102.65L1235.8 2075.21L1234.35 2071.48L1230.62 2072.92L1128.36 2112.57Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.45 2102.17C1178.24 2101.78 1177.93 2101.54 1177.5 2101.45C1177.08 2101.36 1176.62 2101.41 1176.13 2101.6C1175.77 2101.74 1175.47 2101.92 1175.25 2102.14C1175.03 2102.36 1174.88 2102.61 1174.81 2102.87C1174.74 2103.13 1174.75 2103.39 1174.86 2103.65C1174.94 2103.87 1175.06 2104.03 1175.23 2104.15C1175.39 2104.26 1175.58 2104.34 1175.78 2104.38C1175.99 2104.42 1176.19 2104.43 1176.4 2104.43C1176.6 2104.42 1176.79 2104.41 1176.95 2104.39L1177.87 2104.29C1178.1 2104.27 1178.36 2104.25 1178.66 2104.25C1178.96 2104.25 1179.26 2104.28 1179.57 2104.36C1179.87 2104.43 1180.16 2104.57 1180.41 2104.77C1180.67 2104.97 1180.87 2105.27 1181.02 2105.65C1181.19 2106.09 1181.23 2106.53 1181.14 2106.97C1181.05 2107.42 1180.82 2107.83 1180.47 2108.21C1180.11 2108.59 1179.62 2108.9 1178.99 2109.14C1178.41 2109.36 1177.87 2109.47 1177.37 2109.44C1176.87 2109.42 1176.44 2109.29 1176.06 2109.05C1175.69 2108.8 1175.41 2108.46 1175.2 2108.03L1176.22 2107.64C1176.36 2107.93 1176.57 2108.15 1176.82 2108.28C1177.08 2108.41 1177.37 2108.47 1177.69 2108.46C1178.01 2108.44 1178.33 2108.37 1178.65 2108.25C1179.03 2108.1 1179.34 2107.91 1179.59 2107.67C1179.84 2107.43 1180.01 2107.17 1180.1 2106.88C1180.19 2106.59 1180.18 2106.3 1180.06 2106C1179.96 2105.73 1179.8 2105.54 1179.58 2105.43C1179.36 2105.32 1179.11 2105.26 1178.82 2105.25C1178.54 2105.24 1178.23 2105.25 1177.92 2105.28L1176.81 2105.38C1176.1 2105.44 1175.49 2105.38 1174.99 2105.18C1174.49 2104.99 1174.13 2104.62 1173.92 2104.07C1173.74 2103.61 1173.71 2103.17 1173.83 2102.73C1173.94 2102.29 1174.18 2101.9 1174.52 2101.55C1174.87 2101.2 1175.3 2100.92 1175.82 2100.72C1176.34 2100.51 1176.85 2100.43 1177.33 2100.46C1177.81 2100.48 1178.23 2100.61 1178.59 2100.84C1178.96 2101.07 1179.23 2101.39 1179.4 2101.8L1178.45 2102.17ZM1183.83 2107.1L1182.8 2107.5L1182.63 2098.2L1183.65 2097.81L1189.79 2104.79L1188.76 2105.19L1183.67 2099.28L1183.61 2099.31L1183.83 2107.1ZM1182.98 2103.77L1187.15 2102.16L1187.48 2103.03L1183.32 2104.65L1182.98 2103.77ZM1186.85 2097.57L1186.51 2096.7L1192.61 2094.33L1192.95 2095.21L1190.39 2096.2L1193.21 2103.46L1192.22 2103.85L1189.41 2096.58L1186.85 2097.57Z",
    fill: "#9C9C9C"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.9 2245.05L1032.17 2246.5L1033.62 2250.23L1061.41 2321.91L1062.85 2325.64L1066.58 2324.2L1094.02 2313.56L1097.75 2312.12L1096.3 2308.39L1068.51 2236.7L1067.06 2232.97L1063.33 2234.42L1035.9 2245.05Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.62 2258L1068.7 2254.72L1070.68 2259.6L1069.81 2259.95L1068.23 2256.05L1065.5 2257.16L1066.98 2260.81L1066.11 2261.16L1064.63 2257.51L1061.88 2258.63L1063.49 2262.59L1062.62 2262.94L1060.62 2258ZM1074 2267.78L1065.91 2271.06L1065.53 2270.11L1070.09 2263.13L1070.06 2263.05L1063.71 2265.62L1063.31 2264.64L1071.4 2261.36L1071.78 2262.31L1067.21 2269.32L1067.24 2269.4L1073.61 2266.81L1074 2267.78ZM1074.51 2276.29C1074.74 2276.1 1074.93 2275.88 1075.09 2275.66C1075.24 2275.43 1075.36 2275.19 1075.43 2274.93C1075.5 2274.68 1075.53 2274.42 1075.51 2274.14C1075.48 2273.86 1075.42 2273.58 1075.3 2273.29C1075.1 2272.81 1074.8 2272.42 1074.4 2272.13C1073.99 2271.84 1073.5 2271.67 1072.92 2271.64C1072.35 2271.6 1071.71 2271.72 1071.01 2272.01C1070.31 2272.29 1069.76 2272.65 1069.38 2273.08C1068.99 2273.51 1068.75 2273.97 1068.67 2274.47C1068.58 2274.98 1068.64 2275.48 1068.85 2275.98C1069.03 2276.44 1069.3 2276.81 1069.64 2277.08C1069.98 2277.35 1070.38 2277.52 1070.82 2277.57C1071.27 2277.62 1071.74 2277.54 1072.23 2277.34L1072.29 2277.67L1071.31 2275.24L1072.17 2274.88L1073.42 2277.96L1072.55 2278.32C1071.89 2278.59 1071.25 2278.68 1070.64 2278.59C1070.04 2278.51 1069.5 2278.28 1069.03 2277.89C1068.56 2277.5 1068.19 2276.99 1067.93 2276.35C1067.64 2275.63 1067.55 2274.93 1067.67 2274.25C1067.79 2273.58 1068.1 2272.96 1068.59 2272.41C1069.09 2271.86 1069.77 2271.41 1070.62 2271.06C1071.26 2270.8 1071.87 2270.65 1072.45 2270.62C1073.04 2270.58 1073.57 2270.65 1074.06 2270.82C1074.55 2270.99 1074.98 2271.25 1075.35 2271.6C1075.71 2271.96 1076 2272.39 1076.21 2272.91C1076.39 2273.34 1076.48 2273.76 1076.5 2274.18C1076.53 2274.61 1076.48 2275.01 1076.36 2275.4C1076.25 2275.78 1076.07 2276.14 1075.83 2276.46C1075.59 2276.79 1075.28 2277.07 1074.92 2277.3L1074.51 2276.29Z",
    fill: "#9C9C9C"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.94 2222.55L1090.21 2224L1091.65 2227.73L1119.45 2299.41L1120.89 2303.14L1124.62 2301.7L1152.05 2291.06L1155.78 2289.62L1154.34 2285.89L1126.54 2214.2L1125.1 2210.47L1121.37 2211.92L1093.94 2222.55Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.57 2235.53L1126.66 2232.25L1128.64 2237.13L1127.77 2237.48L1126.19 2233.58L1123.45 2234.69L1124.93 2238.34L1124.06 2238.69L1122.58 2235.04L1119.84 2236.16L1121.44 2240.12L1120.58 2240.47L1118.57 2235.53ZM1131.96 2245.31L1123.87 2248.59L1123.48 2247.64L1128.05 2240.66L1128.01 2240.58L1121.66 2243.15L1121.27 2242.18L1129.35 2238.89L1129.74 2239.84L1125.17 2246.85L1125.2 2246.93L1131.56 2244.34L1131.96 2245.31ZM1132.47 2253.82C1132.7 2253.63 1132.89 2253.42 1133.04 2253.19C1133.2 2252.96 1133.31 2252.72 1133.38 2252.46C1133.45 2252.21 1133.48 2251.95 1133.46 2251.67C1133.44 2251.39 1133.37 2251.11 1133.25 2250.82C1133.06 2250.34 1132.76 2249.95 1132.35 2249.66C1131.94 2249.37 1131.45 2249.2 1130.88 2249.17C1130.3 2249.13 1129.66 2249.26 1128.96 2249.54C1128.26 2249.82 1127.72 2250.18 1127.33 2250.61C1126.95 2251.04 1126.71 2251.51 1126.62 2252.01C1126.54 2252.51 1126.6 2253.01 1126.8 2253.51C1126.99 2253.97 1127.25 2254.34 1127.59 2254.61C1127.94 2254.89 1128.33 2255.05 1128.78 2255.1C1129.22 2255.15 1129.69 2255.07 1130.19 2254.87L1130.25 2255.2L1129.26 2252.77L1130.13 2252.41L1131.38 2255.49L1130.51 2255.85C1129.84 2256.12 1129.21 2256.21 1128.6 2256.13C1127.99 2256.04 1127.45 2255.81 1126.98 2255.42C1126.51 2255.04 1126.15 2254.52 1125.89 2253.88C1125.59 2253.16 1125.51 2252.46 1125.62 2251.79C1125.74 2251.11 1126.05 2250.49 1126.55 2249.94C1127.05 2249.39 1127.73 2248.94 1128.58 2248.59C1129.22 2248.33 1129.83 2248.18 1130.41 2248.15C1130.99 2248.11 1131.53 2248.18 1132.02 2248.35C1132.51 2248.52 1132.93 2248.78 1133.3 2249.14C1133.67 2249.49 1133.96 2249.93 1134.17 2250.44C1134.34 2250.87 1134.44 2251.29 1134.46 2251.72C1134.48 2252.14 1134.44 2252.54 1134.32 2252.93C1134.21 2253.31 1134.03 2253.67 1133.78 2254C1133.54 2254.32 1133.24 2254.6 1132.88 2254.83L1132.47 2253.82Z",
    fill: "#9C9C9C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.82 2202.44L1142.09 2203.89L1143.53 2207.62L1171.32 2279.3L1172.77 2283.03L1176.5 2281.59L1203.93 2270.95L1207.66 2269.51L1206.22 2265.78L1178.42 2194.09L1176.98 2190.36L1173.25 2191.81L1145.82 2202.44Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.43 2215.43L1178.52 2212.15L1180.5 2217.03L1179.63 2217.38L1178.05 2213.48L1175.31 2214.59L1176.79 2218.24L1175.92 2218.59L1174.44 2214.94L1171.7 2216.05L1173.3 2220.02L1172.44 2220.37L1170.43 2215.43ZM1183.81 2225.21L1175.73 2228.49L1175.34 2227.54L1179.9 2220.56L1179.87 2220.48L1173.52 2223.05L1173.13 2222.07L1181.21 2218.79L1181.6 2219.74L1177.03 2226.75L1177.06 2226.83L1183.42 2224.24L1183.81 2225.21ZM1184.33 2233.72C1184.56 2233.52 1184.75 2233.31 1184.9 2233.09C1185.06 2232.86 1185.17 2232.62 1185.24 2232.36C1185.31 2232.11 1185.34 2231.85 1185.32 2231.57C1185.3 2231.29 1185.23 2231.01 1185.11 2230.71C1184.92 2230.24 1184.62 2229.85 1184.21 2229.56C1183.8 2229.27 1183.31 2229.1 1182.74 2229.07C1182.16 2229.03 1181.52 2229.15 1180.82 2229.44C1180.12 2229.72 1179.58 2230.08 1179.19 2230.51C1178.81 2230.94 1178.57 2231.4 1178.48 2231.9C1178.4 2232.4 1178.46 2232.91 1178.66 2233.41C1178.85 2233.87 1179.11 2234.24 1179.45 2234.51C1179.8 2234.78 1180.19 2234.95 1180.63 2235C1181.08 2235.05 1181.55 2234.97 1182.05 2234.77L1182.11 2235.1L1181.12 2232.67L1181.99 2232.31L1183.24 2235.39L1182.37 2235.75C1181.7 2236.02 1181.07 2236.11 1180.46 2236.02C1179.85 2235.94 1179.31 2235.71 1178.84 2235.32C1178.37 2234.93 1178.01 2234.42 1177.74 2233.78C1177.45 2233.06 1177.37 2232.36 1177.48 2231.68C1177.6 2231.01 1177.91 2230.39 1178.41 2229.84C1178.91 2229.29 1179.58 2228.84 1180.44 2228.49C1181.08 2228.23 1181.69 2228.08 1182.27 2228.05C1182.85 2228.01 1183.39 2228.08 1183.88 2228.25C1184.37 2228.42 1184.79 2228.68 1185.16 2229.03C1185.53 2229.39 1185.82 2229.82 1186.03 2230.34C1186.2 2230.77 1186.3 2231.19 1186.32 2231.61C1186.34 2232.04 1186.3 2232.44 1186.18 2232.82C1186.07 2233.21 1185.89 2233.57 1185.64 2233.89C1185.4 2234.22 1185.1 2234.5 1184.74 2234.73L1184.33 2233.72Z",
    fill: "#9C9C9C"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.67 2180.01L1199.94 2181.46L1201.38 2185.19L1229.17 2256.88L1230.62 2260.6L1234.35 2259.16L1261.78 2248.52L1265.51 2247.08L1264.07 2243.35L1236.27 2171.66L1234.83 2167.93L1231.1 2169.38L1203.67 2180.01Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.38 2192.96L1236.47 2189.67L1238.45 2194.56L1237.58 2194.91L1236 2191.01L1233.27 2192.11L1234.75 2195.76L1233.88 2196.12L1232.4 2192.47L1229.65 2193.58L1231.26 2197.55L1230.39 2197.9L1228.38 2192.96ZM1241.77 2202.73L1233.68 2206.01L1233.3 2205.07L1237.86 2198.08L1237.83 2198L1231.48 2200.58L1231.08 2199.6L1239.17 2196.32L1239.55 2197.27L1234.98 2204.27L1235.01 2204.35L1241.38 2201.77L1241.77 2202.73ZM1242.28 2211.25C1242.51 2211.05 1242.7 2210.84 1242.86 2210.61C1243.01 2210.39 1243.13 2210.15 1243.2 2209.89C1243.27 2209.64 1243.3 2209.37 1243.27 2209.1C1243.25 2208.82 1243.18 2208.53 1243.07 2208.24C1242.87 2207.76 1242.57 2207.38 1242.16 2207.09C1241.76 2206.79 1241.27 2206.63 1240.69 2206.59C1240.12 2206.56 1239.48 2206.68 1238.78 2206.97C1238.08 2207.25 1237.53 2207.61 1237.15 2208.04C1236.76 2208.47 1236.52 2208.93 1236.44 2209.43C1236.35 2209.93 1236.41 2210.43 1236.62 2210.93C1236.8 2211.4 1237.07 2211.76 1237.41 2212.04C1237.75 2212.31 1238.15 2212.47 1238.59 2212.52C1239.04 2212.57 1239.51 2212.5 1240 2212.3L1240.06 2212.63L1239.07 2210.19L1239.94 2209.84L1241.19 2212.92L1240.32 2213.27C1239.66 2213.54 1239.02 2213.64 1238.41 2213.55C1237.81 2213.47 1237.27 2213.23 1236.79 2212.85C1236.33 2212.46 1235.96 2211.95 1235.7 2211.3C1235.41 2210.59 1235.32 2209.89 1235.44 2209.21C1235.56 2208.54 1235.87 2207.92 1236.36 2207.36C1236.86 2206.81 1237.54 2206.36 1238.39 2206.02C1239.03 2205.76 1239.64 2205.61 1240.22 2205.57C1240.81 2205.54 1241.34 2205.61 1241.83 2205.78C1242.32 2205.95 1242.75 2206.21 1243.12 2206.56C1243.48 2206.92 1243.77 2207.35 1243.98 2207.87C1244.16 2208.3 1244.25 2208.72 1244.27 2209.14C1244.3 2209.56 1244.25 2209.97 1244.13 2210.35C1244.02 2210.74 1243.84 2211.09 1243.6 2211.42C1243.35 2211.75 1243.05 2212.02 1242.69 2212.26L1242.28 2211.25Z",
    fill: "#9C9C9C"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.7 2157.51L1257.97 2158.96L1259.42 2162.69L1287.21 2234.38L1288.66 2238.1L1292.39 2236.66L1319.82 2226.02L1323.55 2224.58L1322.1 2220.85L1294.31 2149.16L1292.86 2145.43L1289.13 2146.88L1261.7 2157.51Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.35 2170.49L1294.43 2167.21L1296.41 2172.09L1295.55 2172.44L1293.96 2168.54L1291.23 2169.65L1292.71 2173.29L1291.84 2173.65L1290.36 2170L1287.61 2171.11L1289.22 2175.08L1288.35 2175.43L1286.35 2170.49ZM1299.73 2180.26L1291.65 2183.55L1291.26 2182.6L1295.82 2175.61L1295.79 2175.54L1289.44 2178.11L1289.04 2177.13L1297.13 2173.85L1297.52 2174.8L1292.94 2181.8L1292.98 2181.88L1299.34 2179.3L1299.73 2180.26ZM1300.24 2188.78C1300.47 2188.58 1300.67 2188.37 1300.82 2188.14C1300.98 2187.92 1301.09 2187.68 1301.16 2187.42C1301.23 2187.17 1301.26 2186.9 1301.24 2186.63C1301.22 2186.35 1301.15 2186.07 1301.03 2185.77C1300.83 2185.29 1300.53 2184.91 1300.13 2184.62C1299.72 2184.33 1299.23 2184.16 1298.65 2184.12C1298.08 2184.09 1297.44 2184.21 1296.74 2184.5C1296.04 2184.78 1295.5 2185.14 1295.11 2185.57C1294.72 2186 1294.49 2186.46 1294.4 2186.96C1294.32 2187.46 1294.38 2187.96 1294.58 2188.46C1294.77 2188.93 1295.03 2189.3 1295.37 2189.57C1295.72 2189.84 1296.11 2190 1296.55 2190.05C1297 2190.11 1297.47 2190.03 1297.97 2189.83L1298.02 2190.16L1297.04 2187.72L1297.91 2187.37L1299.16 2190.45L1298.29 2190.8C1297.62 2191.07 1296.98 2191.17 1296.38 2191.08C1295.77 2191 1295.23 2190.77 1294.76 2190.38C1294.29 2189.99 1293.92 2189.48 1293.66 2188.84C1293.37 2188.12 1293.29 2187.42 1293.4 2186.74C1293.52 2186.07 1293.83 2185.45 1294.33 2184.9C1294.83 2184.34 1295.5 2183.89 1296.36 2183.55C1297 2183.29 1297.61 2183.14 1298.19 2183.11C1298.77 2183.07 1299.31 2183.14 1299.79 2183.31C1300.28 2183.48 1300.71 2183.74 1301.08 2184.09C1301.45 2184.45 1301.73 2184.88 1301.95 2185.4C1302.12 2185.83 1302.22 2186.25 1302.24 2186.67C1302.26 2187.1 1302.21 2187.5 1302.1 2187.88C1301.98 2188.27 1301.8 2188.63 1301.56 2188.95C1301.32 2189.28 1301.02 2189.56 1300.65 2189.79L1300.24 2188.78Z",
    fill: "#9C9C9C"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.55 2135.08L1315.82 2136.53L1317.27 2140.26L1345.06 2211.95L1346.51 2215.67L1350.24 2214.23L1377.67 2203.59L1381.4 2202.15L1379.95 2198.42L1352.16 2126.73L1350.71 2123L1346.98 2124.45L1319.55 2135.08Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.3 2148.01L1352.39 2144.73L1354.37 2149.61L1353.5 2149.97L1351.92 2146.06L1349.19 2147.17L1350.67 2150.82L1349.8 2151.17L1348.32 2147.53L1345.57 2148.64L1347.18 2152.61L1346.31 2152.96L1344.3 2148.01ZM1357.69 2157.79L1349.6 2161.07L1349.22 2160.13L1353.78 2153.14L1353.75 2153.06L1347.4 2155.64L1347 2154.66L1355.09 2151.38L1355.47 2152.33L1350.9 2159.33L1350.93 2159.41L1357.3 2156.83L1357.69 2157.79ZM1358.2 2166.31C1358.43 2166.11 1358.62 2165.9 1358.77 2165.67C1358.93 2165.45 1359.04 2165.21 1359.12 2164.95C1359.19 2164.7 1359.21 2164.43 1359.19 2164.15C1359.17 2163.88 1359.1 2163.59 1358.98 2163.3C1358.79 2162.82 1358.49 2162.44 1358.08 2162.14C1357.68 2161.85 1357.19 2161.69 1356.61 2161.65C1356.03 2161.62 1355.4 2161.74 1354.7 2162.02C1354 2162.31 1353.45 2162.66 1353.06 2163.09C1352.68 2163.52 1352.44 2163.99 1352.36 2164.49C1352.27 2164.99 1352.33 2165.49 1352.53 2165.99C1352.72 2166.45 1352.99 2166.82 1353.33 2167.1C1353.67 2167.37 1354.06 2167.53 1354.51 2167.58C1354.96 2167.63 1355.43 2167.56 1355.92 2167.36L1355.98 2167.68L1354.99 2165.25L1355.86 2164.9L1357.11 2167.98L1356.24 2168.33C1355.58 2168.6 1354.94 2168.69 1354.33 2168.61C1353.73 2168.53 1353.19 2168.29 1352.71 2167.91C1352.24 2167.52 1351.88 2167.01 1351.62 2166.36C1351.33 2165.65 1351.24 2164.95 1351.36 2164.27C1351.48 2163.59 1351.78 2162.98 1352.28 2162.42C1352.78 2161.87 1353.46 2161.42 1354.31 2161.08C1354.95 2160.82 1355.56 2160.67 1356.14 2160.63C1356.72 2160.6 1357.26 2160.67 1357.75 2160.84C1358.24 2161.01 1358.67 2161.27 1359.03 2161.62C1359.4 2161.97 1359.69 2162.41 1359.9 2162.93C1360.07 2163.36 1360.17 2163.78 1360.19 2164.2C1360.21 2164.62 1360.17 2165.03 1360.05 2165.41C1359.94 2165.8 1359.76 2166.15 1359.51 2166.48C1359.27 2166.8 1358.97 2167.08 1358.61 2167.32L1358.2 2166.31Z",
    fill: "#9C9C9C"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.1 2113.17L1372.37 2114.61L1373.81 2118.34L1401.61 2190.03L1403.05 2193.76L1406.78 2192.31L1434.21 2181.68L1437.94 2180.23L1436.5 2176.5L1408.7 2104.81L1407.26 2101.08L1403.53 2102.53L1376.1 2113.17Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1400.74 2126.14L1408.83 2122.86L1410.81 2127.74L1409.94 2128.09L1408.36 2124.19L1405.62 2125.3L1407.1 2128.95L1406.23 2129.3L1404.75 2125.65L1402.01 2126.77L1403.61 2130.73L1402.75 2131.08L1400.74 2126.14ZM1414.13 2135.92L1406.04 2139.2L1405.65 2138.25L1410.22 2131.27L1410.18 2131.19L1403.83 2133.76L1403.44 2132.79L1411.52 2129.5L1411.91 2130.45L1407.34 2137.46L1407.37 2137.54L1413.73 2134.95L1414.13 2135.92ZM1414.64 2144.43C1414.87 2144.24 1415.06 2144.02 1415.21 2143.8C1415.37 2143.57 1415.48 2143.33 1415.55 2143.07C1415.62 2142.82 1415.65 2142.56 1415.63 2142.28C1415.61 2142 1415.54 2141.72 1415.42 2141.43C1415.23 2140.95 1414.93 2140.56 1414.52 2140.27C1414.11 2139.98 1413.62 2139.81 1413.05 2139.78C1412.47 2139.74 1411.83 2139.86 1411.13 2140.15C1410.43 2140.43 1409.89 2140.79 1409.5 2141.22C1409.12 2141.65 1408.88 2142.11 1408.79 2142.62C1408.71 2143.12 1408.77 2143.62 1408.97 2144.12C1409.16 2144.58 1409.42 2144.95 1409.76 2145.22C1410.11 2145.49 1410.5 2145.66 1410.95 2145.71C1411.39 2145.76 1411.86 2145.68 1412.36 2145.48L1412.42 2145.81L1411.43 2143.38L1412.3 2143.02L1413.55 2146.1L1412.68 2146.46C1412.01 2146.73 1411.38 2146.82 1410.77 2146.73C1410.16 2146.65 1409.62 2146.42 1409.15 2146.03C1408.68 2145.64 1408.32 2145.13 1408.06 2144.49C1407.76 2143.77 1407.68 2143.07 1407.79 2142.4C1407.91 2141.72 1408.22 2141.1 1408.72 2140.55C1409.22 2140 1409.9 2139.55 1410.75 2139.2C1411.39 2138.94 1412 2138.79 1412.58 2138.76C1413.16 2138.72 1413.7 2138.79 1414.19 2138.96C1414.68 2139.13 1415.1 2139.39 1415.47 2139.75C1415.84 2140.1 1416.13 2140.54 1416.34 2141.05C1416.51 2141.48 1416.61 2141.9 1416.63 2142.33C1416.65 2142.75 1416.61 2143.15 1416.49 2143.54C1416.38 2143.92 1416.2 2144.28 1415.95 2144.6C1415.71 2144.93 1415.41 2145.21 1415.05 2145.44L1414.64 2144.43Z",
    fill: "#9C9C9C"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.95 2090.74L1430.22 2092.18L1431.66 2095.91L1459.46 2167.6L1460.9 2171.33L1464.63 2169.88L1492.06 2159.25L1495.79 2157.8L1494.35 2154.07L1466.55 2082.38L1465.11 2078.65L1461.38 2080.1L1433.95 2090.74Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.7 2103.67L1466.78 2100.39L1468.76 2105.27L1467.89 2105.62L1466.31 2101.72L1463.58 2102.83L1465.06 2106.47L1464.19 2106.83L1462.71 2103.18L1459.96 2104.29L1461.57 2108.26L1460.7 2108.61L1458.7 2103.67ZM1472.08 2113.44L1463.99 2116.73L1463.61 2115.78L1468.17 2108.79L1468.14 2108.72L1461.79 2111.29L1461.39 2110.31L1469.48 2107.03L1469.86 2107.98L1465.29 2114.98L1465.32 2115.06L1471.69 2112.48L1472.08 2113.44ZM1472.59 2121.96C1472.82 2121.76 1473.01 2121.55 1473.17 2121.32C1473.32 2121.1 1473.44 2120.86 1473.51 2120.6C1473.58 2120.35 1473.61 2120.08 1473.59 2119.81C1473.56 2119.53 1473.5 2119.25 1473.38 2118.95C1473.18 2118.47 1472.88 2118.09 1472.48 2117.8C1472.07 2117.5 1471.58 2117.34 1471 2117.3C1470.43 2117.27 1469.79 2117.39 1469.09 2117.68C1468.39 2117.96 1467.84 2118.32 1467.46 2118.75C1467.07 2119.18 1466.83 2119.64 1466.75 2120.14C1466.66 2120.64 1466.72 2121.14 1466.93 2121.64C1467.11 2122.11 1467.38 2122.47 1467.72 2122.75C1468.06 2123.02 1468.46 2123.18 1468.9 2123.23C1469.35 2123.29 1469.82 2123.21 1470.31 2123.01L1470.37 2123.34L1469.39 2120.9L1470.25 2120.55L1471.5 2123.63L1470.63 2123.98C1469.97 2124.25 1469.33 2124.35 1468.72 2124.26C1468.12 2124.18 1467.58 2123.95 1467.11 2123.56C1466.64 2123.17 1466.27 2122.66 1466.01 2122.02C1465.72 2121.3 1465.63 2120.6 1465.75 2119.92C1465.87 2119.25 1466.18 2118.63 1466.67 2118.08C1467.17 2117.52 1467.85 2117.07 1468.7 2116.73C1469.34 2116.47 1469.95 2116.32 1470.53 2116.29C1471.12 2116.25 1471.65 2116.32 1472.14 2116.49C1472.63 2116.66 1473.06 2116.92 1473.43 2117.27C1473.79 2117.63 1474.08 2118.06 1474.29 2118.58C1474.47 2119.01 1474.56 2119.43 1474.58 2119.85C1474.61 2120.27 1474.56 2120.68 1474.44 2121.06C1474.33 2121.45 1474.15 2121.81 1473.91 2122.13C1473.67 2122.46 1473.36 2122.74 1473 2122.97L1472.59 2121.96Z",
    fill: "#9C9C9C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 2068.24L1488.25 2069.68L1489.7 2073.41L1517.49 2145.1L1518.94 2148.83L1522.67 2147.38L1550.1 2136.75L1553.83 2135.3L1552.38 2131.57L1524.59 2059.88L1523.14 2056.15L1519.41 2057.6L1491.98 2068.24Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1516.65 2081.2L1524.74 2077.92L1526.72 2082.8L1525.85 2083.15L1524.27 2079.25L1521.54 2080.36L1523.02 2084.01L1522.15 2084.36L1520.67 2080.71L1517.92 2081.82L1519.53 2085.79L1518.66 2086.14L1516.65 2081.2ZM1530.04 2090.98L1521.95 2094.26L1521.57 2093.31L1526.13 2086.33L1526.1 2086.25L1519.75 2088.82L1519.35 2087.84L1527.44 2084.56L1527.82 2085.51L1523.25 2092.52L1523.28 2092.59L1529.65 2090.01L1530.04 2090.98ZM1530.55 2099.49C1530.78 2099.29 1530.97 2099.08 1531.13 2098.86C1531.28 2098.63 1531.4 2098.39 1531.47 2098.13C1531.54 2097.88 1531.56 2097.61 1531.54 2097.34C1531.52 2097.06 1531.45 2096.78 1531.34 2096.48C1531.14 2096.01 1530.84 2095.62 1530.43 2095.33C1530.03 2095.04 1529.54 2094.87 1528.96 2094.84C1528.39 2094.8 1527.75 2094.92 1527.05 2095.21C1526.35 2095.49 1525.8 2095.85 1525.42 2096.28C1525.03 2096.71 1524.79 2097.17 1524.71 2097.67C1524.62 2098.17 1524.68 2098.67 1524.89 2099.17C1525.07 2099.64 1525.34 2100.01 1525.68 2100.28C1526.02 2100.55 1526.42 2100.72 1526.86 2100.77C1527.31 2100.82 1527.78 2100.74 1528.27 2100.54L1528.33 2100.87L1527.34 2098.43L1528.21 2098.08L1529.46 2101.16L1528.59 2101.51C1527.93 2101.79 1527.29 2101.88 1526.68 2101.79C1526.08 2101.71 1525.54 2101.48 1525.06 2101.09C1524.59 2100.7 1524.23 2100.19 1523.97 2099.55C1523.68 2098.83 1523.59 2098.13 1523.71 2097.45C1523.83 2096.78 1524.14 2096.16 1524.63 2095.61C1525.13 2095.05 1525.81 2094.61 1526.66 2094.26C1527.3 2094 1527.91 2093.85 1528.49 2093.82C1529.08 2093.78 1529.61 2093.85 1530.1 2094.02C1530.59 2094.19 1531.02 2094.45 1531.39 2094.8C1531.75 2095.16 1532.04 2095.59 1532.25 2096.11C1532.43 2096.54 1532.52 2096.96 1532.54 2097.38C1532.57 2097.81 1532.52 2098.21 1532.4 2098.59C1532.29 2098.98 1532.11 2099.34 1531.87 2099.66C1531.62 2099.99 1531.32 2100.27 1530.96 2100.5L1530.55 2099.49Z",
    fill: "#9C9C9C"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.02 2045.74L1546.29 2047.18L1547.74 2050.91L1575.53 2122.6L1576.97 2126.33L1580.7 2124.88L1608.14 2114.25L1611.86 2112.8L1610.42 2109.07L1582.63 2037.38L1581.18 2033.65L1577.45 2035.1L1550.02 2045.74Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1574.61 2058.73L1582.7 2055.45L1584.68 2060.33L1583.81 2060.68L1582.23 2056.78L1579.49 2057.89L1580.97 2061.54L1580.1 2061.89L1578.62 2058.24L1575.88 2059.36L1577.48 2063.32L1576.61 2063.67L1574.61 2058.73ZM1587.99 2068.51L1579.91 2071.79L1579.52 2070.84L1584.08 2063.86L1584.05 2063.78L1577.7 2066.35L1577.31 2065.37L1585.39 2062.09L1585.78 2063.04L1581.21 2070.05L1581.24 2070.13L1587.6 2067.54L1587.99 2068.51ZM1588.5 2077.02C1588.74 2076.83 1588.93 2076.61 1589.08 2076.39C1589.24 2076.16 1589.35 2075.92 1589.42 2075.66C1589.49 2075.41 1589.52 2075.15 1589.5 2074.87C1589.48 2074.59 1589.41 2074.31 1589.29 2074.02C1589.1 2073.54 1588.8 2073.15 1588.39 2072.86C1587.98 2072.57 1587.49 2072.4 1586.92 2072.37C1586.34 2072.33 1585.7 2072.45 1585 2072.74C1584.3 2073.02 1583.76 2073.38 1583.37 2073.81C1582.98 2074.24 1582.75 2074.7 1582.66 2075.21C1582.58 2075.71 1582.64 2076.21 1582.84 2076.71C1583.03 2077.17 1583.29 2077.54 1583.63 2077.81C1583.98 2078.08 1584.37 2078.25 1584.81 2078.3C1585.26 2078.35 1585.73 2078.27 1586.23 2078.07L1586.29 2078.4L1585.3 2075.97L1586.17 2075.61L1587.42 2078.69L1586.55 2079.05C1585.88 2079.32 1585.25 2079.41 1584.64 2079.32C1584.03 2079.24 1583.49 2079.01 1583.02 2078.62C1582.55 2078.23 1582.18 2077.72 1581.92 2077.08C1581.63 2076.36 1581.55 2075.66 1581.66 2074.99C1581.78 2074.31 1582.09 2073.69 1582.59 2073.14C1583.09 2072.59 1583.76 2072.14 1584.62 2071.79C1585.26 2071.53 1585.87 2071.38 1586.45 2071.35C1587.03 2071.31 1587.57 2071.38 1588.06 2071.55C1588.55 2071.72 1588.97 2071.98 1589.34 2072.34C1589.71 2072.69 1590 2073.13 1590.21 2073.64C1590.38 2074.07 1590.48 2074.49 1590.5 2074.92C1590.52 2075.34 1590.48 2075.74 1590.36 2076.13C1590.25 2076.51 1590.07 2076.87 1589.82 2077.19C1589.58 2077.52 1589.28 2077.8 1588.91 2078.03L1588.5 2077.02Z",
    fill: "#9C9C9C"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.79 2217.21L1056.33 2352.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M996.641 2220.75L1047.19 2355.56",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeDasharray: "5 5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.04 2140.3L1050.28 2227.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.78 2129.16L1078.83 2216.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.75 2120.64L1105.72 2208.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.3 2109.57L1134.46 2196.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.03 2103.25L1155.26 2190.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.58 2092.18L1183.82 2179.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.55 2079.01L1217.78 2166.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.1 2067.95L1246.33 2155.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.28 2052.43L1272.52 2140",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.83 2041.36L1301.07 2128.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.08 2015.45L1377.24 2102.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.34 1980.07L1468.5 2067.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M2587.13 1538.21L2619.37 1625.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M2615.69 1527.14L2647.92 1614.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M2642.58 1518.44L2674.81 1606.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M2671.31 1507.29L2703.36 1594.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M2692.05 1500.98L2724.28 1588.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.46 2170.77L1099.39 2170.83L1099.31 2170.89C1098.36 2171.71 1096.76 2171.76 1095.54 2170.49C1088.67 2163.14 1076.61 2167.82 1076.5 2177.89L1076.5 2177.94L1076.5 2177.98C1076.52 2179.16 1075.37 2180.58 1073.79 2180.72C1064.13 2181.49 1059.85 2193.78 1067.75 2200.04C1069.1 2201.17 1069.22 2202.87 1068.46 2203.95L1068.44 2203.97L1068.42 2204C1062.88 2212.18 1070.01 2222.97 1079.72 2220.91C1081.18 2220.61 1082.66 2221.43 1083.18 2223.03C1086.13 2232.33 1099.03 2233.46 1103.42 2224.61L1103.43 2224.6L1103.43 2224.59C1104.07 2223.29 1105.79 2222.62 1107.14 2223.16L1107.15 2223.16L1107.16 2223.16C1116.38 2226.74 1125.15 2217.19 1121.04 2208.33L1121 2208.24L1120.96 2208.16C1120.34 2206.98 1120.72 2205.32 1122.18 2204.45C1130.69 2199.45 1128.76 2186.78 1119.28 2184.38C1117.62 2183.83 1116.76 2182.41 1116.96 2180.97C1118.57 2171.01 1107.11 2164.82 1099.46 2170.77Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.25 2132.86L1197.17 2132.92L1197.1 2132.98C1196.14 2133.8 1194.55 2133.85 1193.33 2132.58C1186.45 2125.23 1174.4 2129.91 1174.29 2139.98L1174.29 2140.03L1174.29 2140.07C1174.3 2141.25 1173.15 2142.67 1171.57 2142.81C1161.92 2143.58 1157.64 2155.87 1165.54 2162.13C1166.89 2163.26 1167 2164.95 1166.24 2166.04L1166.22 2166.06L1166.2 2166.09C1160.66 2174.27 1167.8 2185.06 1177.51 2183C1178.97 2182.7 1180.45 2183.52 1180.97 2185.12C1183.92 2194.42 1196.82 2195.55 1201.21 2186.7L1201.22 2186.69L1201.22 2186.68C1201.86 2185.38 1203.58 2184.71 1204.93 2185.24L1204.94 2185.25L1204.95 2185.25C1214.17 2188.83 1222.94 2179.28 1218.83 2170.42L1218.79 2170.33L1218.74 2170.25C1218.13 2169.07 1218.51 2167.41 1219.96 2166.54C1228.48 2161.54 1226.55 2148.87 1217.07 2146.47C1215.4 2145.92 1214.55 2144.5 1214.74 2143.06C1216.35 2133.1 1204.9 2126.91 1197.25 2132.86Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M2695.53 756.799L2695.46 756.857L2695.39 756.92C2694.44 757.735 2692.85 757.788 2691.63 756.533C2684.82 749.036 2673.07 754.275 2672.58 763.757L2672.57 763.882L2672.58 764.007C2672.59 765.192 2671.44 766.611 2669.86 766.748C2660.21 767.516 2655.93 779.806 2663.82 786.072C2665.17 787.202 2665.29 788.893 2664.53 789.973L2664.51 790.002L2664.49 790.031C2658.95 798.213 2666.09 808.994 2675.79 806.937C2677.25 806.639 2678.73 807.458 2679.26 809.056C2682.21 818.353 2695.1 819.489 2699.5 810.641L2699.5 810.631L2699.51 810.622C2700.15 809.314 2701.86 808.649 2703.22 809.183L2703.23 809.187L2703.24 809.191C2712.45 812.769 2721.22 803.219 2717.11 794.356L2717.07 794.272L2717.03 794.19C2716.41 793.005 2716.8 791.343 2718.25 790.478C2726.76 785.479 2724.83 772.811 2715.35 770.407C2713.69 769.861 2712.84 768.437 2713.03 766.994C2714.64 757.038 2703.18 750.846 2695.53 756.799Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M2686.57 665.572L2686.5 665.631L2686.42 665.693C2685.47 666.509 2683.89 666.562 2682.67 665.306C2675.94 657.911 2663.83 662.981 2663.61 672.647L2663.61 672.714L2663.61 672.781C2663.63 673.966 2662.48 675.384 2660.9 675.522C2651.24 676.29 2646.96 688.579 2654.86 694.846C2656.21 695.975 2656.33 697.666 2655.57 698.747L2655.55 698.776L2655.53 698.805C2649.99 706.986 2657.12 717.767 2666.83 715.711C2668.29 715.412 2669.77 716.232 2670.29 717.83C2673.24 727.127 2686.14 728.263 2690.53 719.415L2690.54 719.405L2690.54 719.395C2691.18 718.088 2692.9 717.422 2694.25 717.957L2694.26 717.961L2694.27 717.965C2703.49 721.542 2712.26 711.992 2708.15 703.129L2708.11 703.046L2708.07 702.964C2707.45 701.778 2707.83 700.117 2709.29 699.252C2717.8 694.253 2715.87 681.584 2706.39 679.18C2704.73 678.634 2703.87 677.21 2704.07 675.768C2705.68 665.812 2694.22 659.619 2686.57 665.572Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M2669.83 582.414L2669.83 582.409C2663.03 575.283 2651.03 579.937 2650.81 589.783L2650.81 589.85L2650.81 589.918C2650.82 591.103 2649.67 592.521 2648.09 592.658C2638.44 593.426 2634.16 605.716 2642.05 611.982C2643.4 613.112 2643.52 614.803 2642.76 615.884L2642.74 615.912L2642.72 615.941C2637.18 624.123 2644.32 634.904 2654.03 632.847C2655.48 632.549 2656.96 633.368 2657.49 634.966C2660.44 644.264 2673.34 645.399 2677.73 636.551L2677.73 636.542L2677.74 636.532C2678.38 635.224 2680.09 634.559 2681.45 635.093L2681.46 635.097L2681.47 635.101C2690.68 638.679 2699.45 629.129 2695.34 620.266L2695.3 620.182L2695.26 620.1C2694.64 618.915 2695.03 617.254 2696.48 616.388C2704.99 611.39 2703.06 598.721 2693.58 596.317C2691.92 595.771 2691.07 594.347 2691.26 592.905C2692.87 582.948 2681.41 576.756 2673.76 582.709L2673.69 582.768L2673.62 582.83C2672.66 583.652 2671.06 583.699 2669.83 582.414Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M2668.14 509.509L2668.07 509.568L2667.99 509.631C2667.04 510.446 2665.46 510.499 2664.24 509.244C2657.42 501.747 2645.68 506.986 2645.19 516.468L2645.18 516.593L2645.18 516.718C2645.2 517.903 2644.05 519.322 2642.47 519.459C2632.81 520.227 2628.53 532.517 2636.43 538.783C2637.78 539.913 2637.9 541.604 2637.14 542.684L2637.12 542.713L2637.1 542.742C2631.56 550.924 2638.69 561.705 2648.4 559.648C2649.86 559.35 2651.34 560.169 2651.86 561.767C2654.81 571.064 2667.71 572.2 2672.1 563.352L2672.11 563.342L2672.11 563.333C2672.75 562.025 2674.47 561.36 2675.82 561.894L2675.83 561.898L2675.85 561.902C2685.06 565.48 2693.83 555.93 2689.72 547.067L2689.68 546.983L2689.64 546.901C2689.02 545.716 2689.4 544.054 2690.86 543.189C2699.37 538.19 2697.44 525.522 2687.96 523.118C2686.3 522.572 2685.44 521.148 2685.64 519.705C2687.25 509.749 2675.79 503.557 2668.14 509.509Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M2659.46 437.287L2659.39 437.346L2659.31 437.408C2658.36 438.224 2656.78 438.277 2655.56 437.021C2648.83 429.626 2636.72 434.696 2636.5 444.361L2636.5 444.429L2636.5 444.496C2636.52 445.681 2635.37 447.099 2633.79 447.236C2624.13 448.005 2619.85 460.294 2627.75 466.561C2629.1 467.69 2629.22 469.381 2628.46 470.462L2628.44 470.49L2628.42 470.519C2622.88 478.701 2630.01 489.482 2639.72 487.426C2641.18 487.127 2642.66 487.946 2643.18 489.544C2646.14 498.842 2659.03 499.978 2663.42 491.129L2663.43 491.12L2663.43 491.11C2664.07 489.802 2665.79 489.137 2667.15 489.671L2667.16 489.675L2667.17 489.679C2676.38 493.257 2685.15 483.707 2681.04 474.844L2681 474.76L2680.96 474.678C2680.34 473.493 2680.72 471.832 2682.18 470.967C2690.69 465.968 2688.76 453.299 2679.28 450.895C2677.62 450.349 2676.77 448.925 2676.96 447.483C2678.57 437.527 2667.11 431.334 2659.46 437.287Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.33 2098.71L1285.25 2098.77L1285.18 2098.83C1284.23 2099.65 1282.66 2099.7 1281.44 2098.46C1274.55 2090.74 1262.75 2096.02 1262.37 2105.72L1262.37 2105.82L1262.37 2105.92C1262.38 2107.11 1261.23 2108.52 1259.65 2108.66C1250 2109.43 1245.72 2121.72 1253.62 2127.99C1254.97 2129.12 1255.08 2130.81 1254.32 2131.89L1254.3 2131.92L1254.28 2131.94C1248.74 2140.13 1255.88 2150.91 1265.59 2148.85C1267.05 2148.55 1268.53 2149.37 1269.05 2150.97C1272 2160.27 1284.9 2161.4 1289.29 2152.55L1289.3 2152.54L1289.3 2152.54C1289.94 2151.23 1291.66 2150.56 1293.01 2151.1L1293.02 2151.1L1293.03 2151.1C1302.25 2154.68 1311.02 2145.13 1306.91 2136.27L1306.87 2136.19L1306.82 2136.1C1306.21 2134.92 1306.59 2133.26 1308.04 2132.39C1316.56 2127.39 1314.63 2114.72 1305.15 2112.32C1303.48 2111.77 1302.63 2110.35 1302.82 2108.91C1304.43 2098.95 1292.98 2092.76 1285.33 2098.71Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1466.67 2026.05L1466.59 2026.11L1466.52 2026.17C1465.57 2026.99 1463.98 2027.04 1462.76 2025.78C1456.04 2018.39 1443.93 2023.46 1443.71 2033.12L1443.71 2033.19L1443.71 2033.26C1443.72 2034.44 1442.57 2035.86 1440.99 2036C1431.34 2036.77 1427.06 2049.06 1434.96 2055.32C1436.3 2056.45 1436.42 2058.14 1435.66 2059.22L1435.64 2059.25L1435.62 2059.28C1430.08 2067.46 1437.22 2078.24 1446.93 2076.19C1448.38 2075.89 1449.86 2076.71 1450.39 2078.31C1453.34 2087.6 1466.24 2088.74 1470.63 2079.89L1470.63 2079.88L1470.64 2079.87C1471.28 2078.56 1473 2077.9 1474.35 2078.43L1474.36 2078.44L1474.37 2078.44C1483.59 2082.02 1492.35 2072.47 1488.24 2063.61L1488.2 2063.52L1488.16 2063.44C1487.54 2062.25 1487.93 2060.59 1489.38 2059.73C1497.9 2054.73 1495.96 2042.06 1486.48 2039.66C1484.82 2039.11 1483.97 2037.69 1484.16 2036.24C1485.77 2026.29 1474.31 2020.1 1466.67 2026.05Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.87 1990.81L1552.87 1990.8C1546.07 1983.68 1534.06 1988.33 1533.84 1998.18L1533.84 1998.24L1533.84 1998.31C1533.86 1999.5 1532.71 2000.92 1531.13 2001.05C1521.47 2001.82 1517.19 2014.11 1525.09 2020.38C1526.44 2021.51 1526.56 2023.2 1525.8 2024.28L1525.78 2024.31L1525.76 2024.34C1520.22 2032.52 1527.35 2043.3 1537.06 2041.24C1538.52 2040.94 1540 2041.76 1540.52 2043.36C1543.48 2052.66 1556.37 2053.79 1560.76 2044.95L1560.77 2044.94L1560.77 2044.93C1561.41 2043.62 1563.13 2042.95 1564.48 2043.49L1564.49 2043.49L1564.51 2043.5C1573.72 2047.07 1582.49 2037.52 1578.38 2028.66L1578.34 2028.58L1578.3 2028.49C1577.68 2027.31 1578.06 2025.65 1579.52 2024.78C1588.03 2019.78 1586.1 2007.12 1576.62 2004.71C1574.96 2004.17 1574.1 2002.74 1574.3 2001.3C1575.91 1991.34 1564.45 1985.15 1556.8 1991.1L1556.73 1991.16L1556.65 1991.22C1555.7 1992.05 1554.09 1992.09 1552.87 1990.81Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M2744.45 1574.11L2745.94 1577.88L2749.69 1576.34L2776.16 1565.43L2776.16 1565.43L2792.81 1558.54L2795.57 1557.4L2795.26 1554.43L2788.71 1492.12L2788.59 1491.03L2787.94 1490.15L2784.73 1492.54C2787.94 1490.15 2787.93 1490.14 2787.93 1490.14L2787.93 1490.14L2787.93 1490.13L2787.91 1490.11L2787.87 1490.06C2787.84 1490.02 2787.79 1489.96 2787.74 1489.89C2787.63 1489.75 2787.48 1489.56 2787.28 1489.32C2786.88 1488.85 2786.31 1488.2 2785.57 1487.43C2784.09 1485.89 2781.92 1483.85 2779.1 1481.83C2773.47 1477.78 2765.1 1473.67 2754.49 1473.82L2754.46 1473.82L2754.42 1473.82C2750.16 1473.96 2745.65 1474.18 2741.2 1474.59C2733.51 1475.18 2726.1 1476.05 2720.63 1476.77C2717.88 1477.13 2715.62 1477.45 2714.04 1477.68C2713.25 1477.8 2712.62 1477.89 2712.2 1477.96C2711.99 1477.99 2711.82 1478.02 2711.71 1478.03L2711.59 1478.05L2711.55 1478.06L2711.54 1478.06L2711.54 1478.06L2711.54 1478.06C2711.54 1478.06 2711.54 1478.06 2712.17 1482.01L2711.54 1478.06L2706.61 1478.85L2708.45 1483.49L2744.45 1574.11Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M2774.63 1561.73L2741.28 1478.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M2722.76 1500.45L2770.62 1483.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M2729.92 1518.93L2787.04 1498.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M2738.75 1541.71L2786.54 1524.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M2745.84 1560L2793.64 1543.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-330-outside-3_899_2074",
    maskUnits: "userSpaceOnUse",
    x: 2301.06,
    y: 334.142,
    width: 733.318,
    height: 1127.25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2301.06,
    y: 334.142,
    width: 733.318,
    height: 1127.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706.72 1445.25L2757.53 1385.83L2767.54 1374L2660.44 386.257C2660.44 386.257 2617.69 355.158 2596.98 363.189C2576.26 371.219 2552.8 407.589 2552.8 407.589L2621.82 401.232L2734.48 1350.74L2657.83 1355.12C2657.83 1355.12 2661.54 1391.26 2675.72 1392.42L2757.27 1385.72"
  }))), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M2757.53 1385.83L2763.61 1391.03L2763.62 1391.01L2763.63 1391L2757.53 1385.83ZM2767.54 1374L2773.65 1379.17L2775.86 1376.55L2775.49 1373.14L2767.54 1374ZM2660.44 386.257L2668.4 385.394L2668.02 381.871L2665.15 379.787L2660.44 386.257ZM2552.8 407.589L2546.08 403.252L2537.16 417.063L2553.53 415.555L2552.8 407.589ZM2621.82 401.232L2629.76 400.29L2628.84 392.552L2621.08 393.266L2621.82 401.232ZM2734.48 1350.74L2734.94 1358.73L2743.43 1358.24L2742.43 1349.8L2734.48 1350.74ZM2657.83 1355.12L2657.37 1347.13L2649.01 1347.61L2649.87 1355.94L2657.83 1355.12ZM2675.72 1392.42L2675.07 1400.39L2675.72 1400.45L2676.38 1400.39L2675.72 1392.42ZM2712.8 1450.45L2763.61 1391.03L2751.45 1380.63L2700.64 1440.06L2712.8 1450.45ZM2763.63 1391L2773.65 1379.17L2761.43 1368.83L2751.42 1380.66L2763.63 1391ZM2775.49 1373.14L2668.4 385.394L2652.49 387.119L2759.59 1374.87L2775.49 1373.14ZM2660.44 386.257C2665.15 379.787 2665.15 379.786 2665.15 379.785C2665.15 379.785 2665.14 379.783 2665.14 379.782C2665.14 379.78 2665.14 379.778 2665.13 379.775C2665.12 379.769 2665.11 379.761 2665.1 379.751C2665.07 379.732 2665.04 379.705 2664.99 379.671C2664.9 379.604 2664.76 379.508 2664.59 379.385C2664.24 379.14 2663.75 378.79 2663.11 378.352C2661.84 377.475 2660.02 376.244 2657.77 374.797C2653.29 371.912 2647.06 368.128 2640.11 364.584C2633.21 361.064 2625.34 357.649 2617.63 355.659C2610.13 353.722 2601.59 352.82 2594.09 355.73L2599.87 370.648C2602.72 369.542 2607.3 369.516 2613.63 371.152C2619.76 372.734 2626.47 375.588 2632.84 378.838C2639.17 382.065 2644.92 385.553 2649.11 388.249C2651.19 389.592 2652.87 390.727 2654.02 391.52C2654.6 391.917 2655.04 392.227 2655.33 392.433C2655.47 392.537 2655.58 392.614 2655.65 392.664C2655.69 392.689 2655.71 392.706 2655.73 392.717C2655.73 392.722 2655.74 392.725 2655.74 392.727C2655.74 392.728 2655.74 392.728 2655.74 392.728C2655.74 392.728 2655.74 392.727 2655.74 392.727C2655.74 392.727 2655.74 392.726 2660.44 386.257ZM2594.09 355.73C2587.63 358.232 2581.45 362.713 2576.02 367.532C2570.52 372.419 2565.37 378.034 2560.99 383.264C2556.59 388.511 2552.88 393.48 2550.28 397.133C2548.97 398.963 2547.93 400.473 2547.22 401.534C2546.86 402.065 2546.58 402.484 2546.39 402.775C2546.29 402.921 2546.22 403.035 2546.16 403.115C2546.14 403.155 2546.12 403.187 2546.1 403.21C2546.1 403.221 2546.09 403.23 2546.08 403.237C2546.08 403.241 2546.08 403.244 2546.08 403.246C2546.08 403.248 2546.08 403.249 2546.08 403.25C2546.08 403.251 2546.08 403.252 2552.8 407.589C2559.52 411.926 2559.52 411.927 2559.52 411.928C2559.52 411.928 2559.52 411.929 2559.52 411.929C2559.52 411.929 2559.52 411.929 2559.52 411.928C2559.52 411.926 2559.52 411.922 2559.53 411.916C2559.53 411.904 2559.55 411.883 2559.57 411.854C2559.6 411.796 2559.66 411.705 2559.74 411.582C2559.91 411.337 2560.15 410.967 2560.48 410.488C2561.12 409.528 2562.08 408.134 2563.3 406.429C2565.74 403.012 2569.19 398.387 2573.25 393.537C2577.33 388.671 2581.93 383.688 2586.65 379.497C2591.44 375.238 2595.97 372.161 2599.87 370.648L2594.09 355.73ZM2553.53 415.555L2622.55 409.199L2621.08 393.266L2552.06 399.623L2553.53 415.555ZM2613.87 402.175L2726.54 1351.69L2742.43 1349.8L2629.76 400.29L2613.87 402.175ZM2734.03 1342.76L2657.37 1347.13L2658.28 1363.11L2734.94 1358.73L2734.03 1342.76ZM2657.83 1355.12C2649.87 1355.94 2649.87 1355.94 2649.87 1355.94C2649.87 1355.94 2649.87 1355.94 2649.87 1355.94C2649.87 1355.95 2649.87 1355.95 2649.87 1355.96C2649.87 1355.96 2649.87 1355.98 2649.87 1355.99C2649.88 1356.01 2649.88 1356.05 2649.89 1356.09C2649.89 1356.18 2649.91 1356.29 2649.93 1356.45C2649.96 1356.75 2650.01 1357.17 2650.08 1357.71C2650.22 1358.78 2650.44 1360.29 2650.74 1362.1C2651.34 1365.7 2652.31 1370.59 2653.78 1375.59C2655.22 1380.5 2657.29 1386 2660.26 1390.51C2663.15 1394.89 2667.91 1399.81 2675.07 1400.39L2676.37 1384.45C2676.35 1384.45 2676.16 1384.44 2675.69 1384.1C2675.17 1383.7 2674.45 1382.97 2673.62 1381.7C2671.91 1379.11 2670.39 1375.35 2669.13 1371.08C2667.9 1366.9 2667.06 1362.68 2666.52 1359.47C2666.25 1357.87 2666.07 1356.55 2665.95 1355.64C2665.89 1355.19 2665.85 1354.84 2665.82 1354.61C2665.81 1354.49 2665.8 1354.41 2665.79 1354.36C2665.79 1354.33 2665.79 1354.32 2665.79 1354.31C2665.79 1354.3 2665.78 1354.3 2665.78 1354.3C2665.78 1354.3 2665.78 1354.3 2665.78 1354.3C2665.79 1354.3 2665.79 1354.3 2665.79 1354.3C2665.79 1354.3 2665.79 1354.3 2657.83 1355.12ZM2676.38 1400.39L2757.93 1393.69L2756.61 1377.74L2675.07 1384.45L2676.38 1400.39Z",
    fill: "#9C9C9C",
    mask: "url(#path-330-outside-3_899_2074)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M2758.5 1382.23L2640.46 374.031",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M2586.01 402.442L2581.98 375.443",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M2608.99 400.834L2604.75 362.752",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M2570.63 387.145L2653.35 382.349",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M2625.27 412.348L2660.72 409.124",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M2921.67 623.199L3004.34 619.927",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M2926.79 649.133L3009.53 646.047",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M2929.28 681.023L3011.83 678.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M2934.33 709.559L3016.99 706.286",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M2990.08 1101.97L3072.82 1098.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M2995.27 1128.09L3078.01 1125",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M2997.76 1159.98L3080.49 1156.9",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M3002.74 1188.33L3085.47 1185.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M3002.63 1220.16L3085.29 1216.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M3007.74 1246.09L3090.29 1243.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M3010.23 1277.98L3092.78 1274.97",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M3015.29 1306.52L3097.95 1303.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M2606.25 795.738L2702.24 787.516",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M2610.69 822.145L2706.61 813.736",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M2611.62 854.43L2707.42 846.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M2615.74 883.324L2711.72 875.102",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-353-outside-4_899_2074",
    maskUnits: "userSpaceOnUse",
    x: 2644.47,
    y: 823.774,
    width: 138.227,
    height: 217.583,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2644.47,
    y: 823.774,
    width: 138.227,
    height: 217.583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2693.7 832.488C2693.7 832.488 2731.77 880.862 2733.36 934.791C2734.95 988.72 2723.81 1033.63 2723.81 1033.63"
  }))), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M2693.7 832.488C2687.41 837.435 2687.41 837.434 2687.41 837.433C2687.41 837.433 2687.41 837.432 2687.41 837.431C2687.41 837.43 2687.41 837.431 2687.41 837.431C2687.41 837.433 2687.41 837.437 2687.42 837.445C2687.43 837.459 2687.45 837.486 2687.48 837.523C2687.54 837.599 2687.63 837.719 2687.76 837.884C2688.01 838.214 2688.39 838.721 2688.88 839.393C2689.86 840.739 2691.29 842.747 2693.02 845.334C2696.48 850.514 2701.13 857.985 2705.82 867.084C2715.27 885.399 2724.62 909.748 2725.36 935.026L2741.36 934.555C2740.51 905.905 2730.03 879.101 2720.04 859.748C2715.02 850.012 2710.05 842.019 2706.32 836.443C2704.46 833.653 2702.9 831.46 2701.79 829.95C2701.24 829.194 2700.8 828.609 2700.49 828.204C2700.34 828.001 2700.22 827.844 2700.13 827.733C2700.09 827.677 2700.06 827.633 2700.03 827.601C2700.02 827.585 2700.01 827.572 2700 827.561C2700 827.556 2699.99 827.552 2699.99 827.548C2699.99 827.547 2699.99 827.544 2699.99 827.543C2699.98 827.542 2699.98 827.54 2693.7 832.488ZM2725.36 935.026C2726.14 961.405 2723.8 985.635 2721.26 1003.29C2719.99 1012.11 2718.67 1019.26 2717.68 1024.18C2717.18 1026.65 2716.77 1028.55 2716.48 1029.83C2716.33 1030.46 2716.22 1030.95 2716.15 1031.26C2716.11 1031.42 2716.08 1031.53 2716.06 1031.61C2716.05 1031.64 2716.05 1031.67 2716.04 1031.69C2716.04 1031.69 2716.04 1031.7 2716.04 1031.7C2716.04 1031.7 2716.04 1031.7 2716.04 1031.7C2716.04 1031.7 2716.04 1031.7 2716.04 1031.7C2716.04 1031.7 2716.04 1031.7 2723.81 1033.63C2731.57 1035.55 2731.57 1035.55 2731.57 1035.55C2731.57 1035.55 2731.57 1035.55 2731.57 1035.55C2731.57 1035.54 2731.57 1035.54 2731.57 1035.53C2731.58 1035.53 2731.58 1035.51 2731.58 1035.5C2731.59 1035.47 2731.6 1035.43 2731.61 1035.38C2731.64 1035.28 2731.67 1035.14 2731.71 1034.96C2731.8 1034.59 2731.93 1034.05 2732.08 1033.36C2732.4 1031.97 2732.84 1029.94 2733.36 1027.35C2734.41 1022.17 2735.78 1014.72 2737.1 1005.57C2739.73 987.294 2742.17 962.106 2741.36 934.555L2725.36 935.026Z",
    fill: "#9C9C9C",
    mask: "url(#path-353-outside-4_899_2074)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M2791.84 970.198L2795.78 969.636L2795.23 965.692L2790.85 933.892L2790.85 933.888L2780.17 857.069L2779.62 853.101L2775.65 853.658L2753.06 856.835L2749.11 857.391L2749.65 861.342L2760.18 937.776L2760.18 937.788L2764.53 970.021L2765.06 974.016L2769.05 973.447L2791.84 970.198Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M2764.15 937.242L2786.89 934.439",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M2761.88 908.699L2784.62 905.896",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M2757.46 884L2780.2 881.197",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M2798.06 718.021L2798.13 718.659C2798.12 718.76 2798.12 718.888 2798.11 719.042L2798.1 719.464C2798.08 720.171 2798.05 721.21 2798.02 722.544C2797.95 725.212 2797.86 729.059 2797.77 733.785C2797.59 743.235 2797.42 756.201 2797.45 770.263C2797.51 798.241 2798.37 831.027 2801.67 848.882C2804.85 866.141 2822.66 1017.53 2839.71 1164.93C2848.22 1238.56 2856.54 1311.1 2862.72 1365.23C2865.81 1392.3 2868.37 1414.76 2870.16 1430.46C2871.06 1438.31 2871.76 1444.47 2872.23 1448.66L2872.78 1453.45L2872.92 1454.67L2872.95 1454.98L2872.96 1455.06L2872.96 1455.08C2872.96 1455.09 2872.96 1455.09 2876.94 1454.64L2872.96 1455.09L2873.41 1459L2877.33 1458.62L3022.7 1444.35L3026.68 1443.96L3026.29 1439.98L2963.1 797.479L2963.03 796.704L2962.66 796.014L2962.66 796.013L2962.66 796.007L2962.65 795.979L2962.58 795.858C2962.53 795.747 2962.44 795.579 2962.33 795.354C2962.1 794.903 2961.76 794.227 2961.32 793.338C2960.45 791.558 2959.18 788.925 2957.64 785.538C2954.57 778.763 2950.39 768.977 2946 756.978C2937.22 732.957 2927.66 700.179 2924.39 664.981L2924.39 664.963L2924.39 664.944L2893.38 360.759L2956.1 351.831L2961.23 351.101L2959.22 346.324L2928 271.886L2927.84 271.502L2927.6 271.16L2924.31 273.433C2927.6 271.16 2927.6 271.158 2927.6 271.156L2927.6 271.152L2927.59 271.139L2927.56 271.1C2927.54 271.069 2927.51 271.027 2927.47 270.975C2927.44 270.927 2927.4 270.87 2927.35 270.806C2927.3 270.728 2927.23 270.639 2927.16 270.538C2926.88 270.167 2926.48 269.642 2925.96 268.992C2924.91 267.691 2923.38 265.882 2921.36 263.791C2917.34 259.617 2911.37 254.278 2903.57 249.628C2887.88 240.267 2864.88 233.775 2836 244.97C2808.57 255.605 2788.63 265.647 2776.16 280.744C2763.5 296.069 2759.02 315.954 2760.78 344.976C2762.51 373.62 2771.86 467.178 2780.77 553.433C2785.22 596.592 2789.57 637.966 2792.8 668.551C2794.42 683.843 2795.76 696.438 2796.69 705.21C2797.16 709.596 2797.52 713.027 2797.77 715.36L2798.06 718.021Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M2809.19 769.113L2809.18 769.108C2802.39 761.983 2790.38 766.636 2790.16 776.482L2790.16 776.55L2790.16 776.617C2790.17 777.802 2789.03 779.22 2787.44 779.358C2777.79 780.126 2773.51 792.415 2781.41 798.682C2782.76 799.811 2782.88 801.502 2782.12 802.583L2782.1 802.612L2782.08 802.641C2776.54 810.822 2783.67 821.603 2793.38 819.547C2794.84 819.248 2796.32 820.068 2796.84 821.665C2799.79 830.963 2812.69 832.099 2817.08 823.25L2817.09 823.241L2817.09 823.231C2817.73 821.924 2819.45 821.258 2820.8 821.792L2820.81 821.796L2820.82 821.8C2830.04 825.378 2838.81 815.828 2834.7 806.965L2834.66 806.881L2834.62 806.799C2834 805.614 2834.38 803.953 2835.84 803.088C2844.35 798.089 2842.42 785.42 2832.94 783.016C2831.28 782.47 2830.42 781.046 2830.61 779.604C2832.22 769.648 2820.77 763.455 2813.12 769.408L2813.04 769.467L2812.97 769.529C2812.01 770.351 2810.41 770.399 2809.19 769.113Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M2898.29 722.217L2898.22 722.275L2898.14 722.338C2897.19 723.153 2895.61 723.207 2894.39 721.951C2887.57 714.454 2875.83 719.693 2875.34 729.175L2875.33 729.3L2875.33 729.425C2875.35 730.61 2874.2 732.029 2872.62 732.166C2862.96 732.934 2858.68 745.224 2866.58 751.49C2867.93 752.62 2868.05 754.311 2867.29 755.391L2867.27 755.42L2867.25 755.449C2861.71 763.63 2868.84 774.412 2878.55 772.355C2880.01 772.057 2881.49 772.876 2882.01 774.474C2884.97 783.772 2897.86 784.907 2902.26 776.059L2902.26 776.049L2902.26 776.04C2902.9 774.732 2904.62 774.067 2905.98 774.601L2905.99 774.605L2906 774.609C2915.21 778.187 2923.98 768.637 2919.87 759.774L2919.83 759.69L2919.79 759.608C2919.17 758.423 2919.55 756.761 2921.01 755.896C2929.52 750.897 2927.59 738.229 2918.11 735.825C2916.45 735.279 2915.59 733.855 2915.79 732.412C2917.4 722.456 2905.94 716.264 2898.29 722.217Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M2902.44 629.242L2902.43 629.237C2895.63 622.112 2883.63 626.765 2883.41 636.611L2883.41 636.679L2883.41 636.746C2883.42 637.931 2882.27 639.349 2880.69 639.486C2871.04 640.255 2866.76 652.544 2874.65 658.811C2876 659.94 2876.12 661.631 2875.36 662.712L2875.34 662.74L2875.32 662.769C2869.78 670.951 2876.92 681.732 2886.63 679.676C2888.08 679.377 2889.56 680.197 2890.09 681.794C2893.04 691.092 2905.94 692.228 2910.33 683.379L2910.33 683.37L2910.34 683.36C2910.98 682.052 2912.7 681.387 2914.05 681.921L2914.06 681.925L2914.07 681.929C2923.29 685.507 2932.05 675.957 2927.94 667.094L2927.9 667.01L2927.86 666.928C2927.24 665.743 2927.63 664.082 2929.08 663.217C2937.6 658.218 2935.66 645.549 2926.18 643.145C2924.52 642.599 2923.67 641.175 2923.86 639.733C2925.47 629.777 2914.01 623.584 2906.37 629.537L2906.29 629.596L2906.22 629.658C2905.26 630.48 2903.66 630.528 2902.44 629.242Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M2868.44 514.433L2868.44 514.428C2861.64 507.303 2849.64 511.956 2849.42 521.803L2849.41 521.87L2849.42 521.937C2849.43 523.122 2848.28 524.541 2846.7 524.678C2837.05 525.446 2832.76 537.735 2840.66 544.002C2842.01 545.132 2842.13 546.823 2841.37 547.903L2841.35 547.932L2841.33 547.961C2835.79 556.142 2842.93 566.924 2852.63 564.867C2854.09 564.568 2855.57 565.388 2856.1 566.986C2859.05 576.283 2871.94 577.419 2876.34 568.571L2876.34 568.561L2876.35 568.551C2876.99 567.244 2878.7 566.578 2880.06 567.113L2880.07 567.117L2880.08 567.121C2889.29 570.699 2898.06 561.148 2893.95 552.286L2893.91 552.202L2893.87 552.12C2893.25 550.934 2893.64 549.273 2895.09 548.408C2903.6 543.409 2901.67 530.74 2892.19 528.336C2890.53 527.79 2889.68 526.366 2889.87 524.924C2891.48 514.968 2880.02 508.775 2872.37 514.728L2872.3 514.787L2872.23 514.849C2871.27 515.671 2869.67 515.719 2868.44 514.433Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M2888.25 415.591L2888.17 415.65L2888.1 415.712C2887.15 416.532 2885.55 416.581 2884.33 415.307C2877.45 407.959 2865.4 412.641 2865.29 422.713L2865.29 422.756L2865.29 422.8C2865.31 423.985 2864.16 425.403 2862.58 425.541C2852.92 426.309 2848.64 438.598 2856.54 444.865C2857.89 445.994 2858.01 447.685 2857.25 448.766L2857.23 448.795L2857.21 448.824C2851.67 457.005 2858.8 467.786 2868.51 465.73C2869.97 465.431 2871.45 466.251 2871.97 467.848C2874.92 477.146 2887.82 478.282 2892.21 469.434L2892.22 469.424L2892.22 469.414C2892.86 468.107 2894.58 467.441 2895.93 467.975L2895.94 467.979L2895.95 467.983C2905.17 471.561 2913.94 462.011 2909.83 453.148L2909.79 453.064L2909.75 452.982C2909.13 451.797 2909.51 450.136 2910.97 449.271C2919.48 444.272 2917.55 431.603 2908.07 429.199C2906.41 428.653 2905.55 427.229 2905.75 425.787C2907.35 415.831 2895.9 409.638 2888.25 415.591Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M2840.96 339.006L2840.88 339.064L2840.81 339.127C2839.86 339.942 2838.28 339.996 2837.06 338.74C2830.24 331.243 2818.49 336.482 2818 345.964L2818 346.089L2818 346.214C2818.01 347.399 2816.86 348.818 2815.28 348.955C2805.63 349.723 2801.35 362.013 2809.25 368.279C2810.59 369.409 2810.71 371.1 2809.95 372.18L2809.93 372.209L2809.91 372.238C2804.37 380.419 2811.51 391.201 2821.22 389.144C2822.67 388.846 2824.15 389.665 2824.68 391.263C2827.63 400.561 2840.53 401.696 2844.92 392.848L2844.93 392.838L2844.93 392.829C2845.57 391.521 2847.29 390.856 2848.64 391.39L2848.65 391.394L2848.66 391.398C2857.88 394.976 2866.65 385.426 2862.53 376.563L2862.5 376.479L2862.45 376.397C2861.84 375.212 2862.22 373.551 2863.67 372.685C2872.19 367.686 2870.25 355.018 2860.78 352.614C2859.11 352.068 2858.26 350.644 2858.45 349.201C2860.06 339.245 2848.6 333.053 2840.96 339.006Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M2848.25 253.717L2848.17 253.775L2848.1 253.838C2847.15 254.653 2845.57 254.706 2844.35 253.451C2837.62 246.055 2825.51 251.126 2825.29 260.791L2825.29 260.858L2825.29 260.925C2825.3 262.11 2824.15 263.529 2822.57 263.666C2812.92 264.434 2808.64 276.724 2816.54 282.99C2817.89 284.12 2818 285.811 2817.25 286.891L2817.22 286.92L2817.21 286.949C2811.67 295.131 2818.8 305.912 2828.51 303.855C2829.97 303.557 2831.45 304.376 2831.97 305.974C2834.92 315.271 2847.82 316.407 2852.21 307.559L2852.22 307.549L2852.22 307.54C2852.86 306.232 2854.58 305.567 2855.93 306.101L2855.94 306.105L2855.95 306.109C2865.17 309.687 2873.94 300.137 2869.83 291.274L2869.79 291.19L2869.74 291.108C2869.13 289.923 2869.51 288.261 2870.96 287.396C2879.48 282.397 2877.55 269.729 2868.07 267.325C2866.4 266.779 2865.55 265.355 2865.74 263.912C2867.35 253.956 2855.9 247.764 2848.25 253.717Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M2923.55 868.756L2923.47 868.814L2923.4 868.877C2922.45 869.692 2920.87 869.746 2919.65 868.49C2912.92 861.094 2900.81 866.165 2900.59 875.83L2900.59 875.897L2900.59 875.964C2900.6 877.149 2899.45 878.568 2897.87 878.705C2888.22 879.473 2883.94 891.763 2891.84 898.029C2893.18 899.159 2893.3 900.85 2892.54 901.93L2892.52 901.959L2892.5 901.988C2886.96 910.17 2894.1 920.951 2903.81 918.894C2905.26 918.596 2906.74 919.415 2907.27 921.013C2910.22 930.31 2923.12 931.447 2927.51 922.598L2927.52 922.588L2927.52 922.579C2928.16 921.271 2929.88 920.606 2931.23 921.14L2931.24 921.144L2931.25 921.148C2940.47 924.726 2949.23 915.176 2945.12 906.313L2945.09 906.229L2945.04 906.147C2944.43 904.962 2944.81 903.301 2946.26 902.435C2954.78 897.436 2952.84 884.768 2943.37 882.364C2941.7 881.818 2940.85 880.394 2941.04 878.952C2942.65 868.995 2931.2 862.803 2923.55 868.756Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M2904.7 1042.6L2904.7 1042.6C2897.9 1035.47 2885.89 1040.13 2885.67 1049.97L2885.67 1050.04L2885.67 1050.11C2885.69 1051.29 2884.54 1052.71 2882.96 1052.85C2873.3 1053.62 2869.02 1065.91 2876.92 1072.17C2878.27 1073.3 2878.39 1074.99 2877.63 1076.07L2877.61 1076.1L2877.59 1076.13C2872.05 1084.31 2879.18 1095.1 2888.89 1093.04C2890.35 1092.74 2891.83 1093.56 2892.35 1095.16C2895.31 1104.46 2908.2 1105.59 2912.6 1096.74L2912.6 1096.73L2912.6 1096.72C2913.24 1095.42 2914.96 1094.75 2916.31 1095.28L2916.33 1095.29L2916.34 1095.29C2925.55 1098.87 2934.32 1089.32 2930.21 1080.46L2930.17 1080.37L2930.13 1080.29C2929.51 1079.11 2929.89 1077.44 2931.35 1076.58C2939.86 1071.58 2937.93 1058.91 2928.45 1056.51C2926.79 1055.96 2925.94 1054.54 2926.13 1053.1C2927.74 1043.14 2916.28 1036.95 2908.63 1042.9L2908.56 1042.96L2908.48 1043.02C2907.53 1043.84 2905.92 1043.89 2904.7 1042.6Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M2960.09 1144.06L2960.01 1144.12L2959.94 1144.19C2958.99 1145 2957.4 1145.05 2956.18 1143.8C2949.46 1136.4 2937.35 1141.47 2937.13 1151.14L2937.13 1151.21L2937.13 1151.27C2937.14 1152.46 2935.99 1153.88 2934.41 1154.01C2924.76 1154.78 2920.48 1167.07 2928.38 1173.34C2929.72 1174.47 2929.84 1176.16 2929.08 1177.24L2929.06 1177.27L2929.04 1177.3C2923.5 1185.48 2930.64 1196.26 2940.35 1194.2C2941.8 1193.9 2943.28 1194.72 2943.81 1196.32C2946.76 1205.62 2959.66 1206.75 2964.05 1197.91L2964.05 1197.9L2964.06 1197.89C2964.7 1196.58 2966.42 1195.91 2967.77 1196.45L2967.78 1196.45L2967.79 1196.46C2977.01 1200.03 2985.77 1190.48 2981.66 1181.62L2981.62 1181.54L2981.58 1181.46C2980.96 1180.27 2981.35 1178.61 2982.8 1177.74C2991.32 1172.75 2989.38 1160.08 2979.9 1157.67C2978.24 1157.13 2977.39 1155.7 2977.58 1154.26C2979.19 1144.3 2967.73 1138.11 2960.09 1144.06Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M2918.05 1270.95L2917.97 1271.01L2917.9 1271.08C2916.95 1271.89 2915.37 1271.94 2914.15 1270.69C2907.42 1263.29 2895.31 1268.36 2895.09 1278.03L2895.09 1278.1L2895.09 1278.16C2895.1 1279.35 2893.96 1280.77 2892.37 1280.9C2882.72 1281.67 2878.44 1293.96 2886.34 1300.23C2887.69 1301.36 2887.81 1303.05 2887.05 1304.13L2887.03 1304.16L2887.01 1304.19C2881.47 1312.37 2888.6 1323.15 2898.31 1321.09C2899.77 1320.8 2901.25 1321.61 2901.77 1323.21C2904.72 1332.51 2917.62 1333.65 2922.01 1324.8L2922.02 1324.79L2922.02 1324.78C2922.66 1323.47 2924.38 1322.81 2925.73 1323.34L2925.74 1323.34L2925.75 1323.35C2934.97 1326.93 2943.74 1317.38 2939.63 1308.51L2939.59 1308.43L2939.54 1308.35C2938.93 1307.16 2939.31 1305.5 2940.76 1304.63C2949.28 1299.64 2947.35 1286.97 2937.87 1284.56C2936.2 1284.02 2935.35 1282.59 2935.54 1281.15C2937.15 1271.19 2925.7 1265 2918.05 1270.95Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M2992.44 1277.33L2992.36 1277.39L2992.29 1277.45C2991.34 1278.27 2989.76 1278.32 2988.55 1277.08C2981.66 1269.36 2969.86 1274.64 2969.48 1284.34L2969.48 1284.44L2969.48 1284.54C2969.49 1285.73 2968.34 1287.15 2966.76 1287.28C2957.11 1288.05 2952.83 1300.34 2960.72 1306.61C2962.07 1307.74 2962.19 1309.43 2961.43 1310.51L2961.41 1310.54L2961.39 1310.57C2955.85 1318.75 2962.99 1329.53 2972.7 1327.47C2974.15 1327.17 2975.63 1327.99 2976.16 1329.59C2979.11 1338.89 2992.01 1340.02 2996.4 1331.18L2996.4 1331.17L2996.41 1331.16C2997.05 1329.85 2998.76 1329.18 3000.12 1329.72L3000.13 1329.72L3000.14 1329.73C3009.36 1333.3 3018.12 1323.75 3014.01 1314.89L3013.97 1314.81L3013.93 1314.72C3013.31 1313.54 3013.7 1311.88 3015.15 1311.01C3023.66 1306.01 3021.73 1293.35 3012.25 1290.94C3010.59 1290.4 3009.74 1288.97 3009.93 1287.53C3011.54 1277.57 3000.08 1271.38 2992.44 1277.33Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M2994.31 1381.83L2994.23 1381.89L2994.16 1381.95C2993.21 1382.77 2991.63 1382.82 2990.41 1381.57C2983.59 1374.07 2971.84 1379.31 2971.36 1388.79L2971.35 1388.92L2971.35 1389.04C2971.36 1390.23 2970.21 1391.65 2968.63 1391.78C2958.98 1392.55 2954.7 1404.84 2962.6 1411.11C2963.95 1412.24 2964.07 1413.93 2963.31 1415.01L2963.29 1415.04L2963.27 1415.07C2957.73 1423.25 2964.86 1434.03 2974.57 1431.97C2976.03 1431.67 2977.51 1432.49 2978.03 1434.09C2980.98 1443.39 2993.88 1444.52 2998.27 1435.68L2998.28 1435.67L2998.28 1435.66C2998.92 1434.35 3000.64 1433.68 3001.99 1434.22L3002 1434.22L3002.01 1434.23C3011.23 1437.8 3020 1428.25 3015.89 1419.39L3015.85 1419.31L3015.8 1419.23C3015.19 1418.04 3015.57 1416.38 3017.02 1415.51C3025.54 1410.51 3023.61 1397.85 3014.13 1395.44C3012.46 1394.9 3011.61 1393.47 3011.8 1392.03C3013.41 1382.07 3001.96 1375.88 2994.31 1381.83Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M3022.83 1467.18L3023.15 1473.08L3028.51 1470.59L3153.34 1412.75L3156.86 1411.12L3155.34 1407.55L3129.62 1347.3L3128.44 1344.53L3125.44 1344.9L3020.63 1358.05L3016.93 1358.51L3017.14 1362.23L3022.83 1467.18Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M3179.35 1327.74L3175.63 1329.18L3177.07 1332.91L3200.23 1392.65L3201.68 1396.38L3205.41 1394.93L3223.69 1387.84L3227.42 1386.4L3225.98 1382.67L3202.82 1322.93L3201.37 1319.2L3197.64 1320.65L3179.35 1327.74Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M3254 1298.8L3250.27 1300.24L3251.72 1303.97L3274.88 1363.71L3276.32 1367.44L3280.05 1366L3298.34 1358.91L3302.07 1357.46L3300.63 1353.73L3277.46 1293.99L3276.02 1290.26L3272.29 1291.71L3254 1298.8Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M3329.95 1269.35L3326.22 1270.8L3327.67 1274.53L3350.83 1334.27L3352.27 1338L3356 1336.55L3374.29 1329.46L3378.02 1328.01L3376.58 1324.29L3353.42 1264.55L3351.97 1260.82L3348.24 1262.26L3329.95 1269.35Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M3155.79 1341.16L3179.41 1399.86",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M3227.64 1313.3L3251.26 1372.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M3304.9 1283.36L3328.52 1342.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M3078.85 1440.57L3401.06 1318.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M3328.48 1328.11L3342.1 1322.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M3320.69 1298.07L3316.96 1299.51L3318.41 1303.24L3323.69 1316.87L3325.14 1320.6L3328.87 1319.15L3338.39 1315.46L3342.11 1314.02L3340.67 1310.29L3335.39 1296.66L3333.94 1292.93L3330.21 1294.38L3320.69 1298.07Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M3336.98 1325.68L3333 1315.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M3298.06 1339.91L3311.49 1334.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M3290.27 1309.86L3286.55 1311.31L3287.99 1315.04L3293.27 1328.66L3294.72 1332.39L3298.45 1330.95L3307.97 1327.26L3311.7 1325.81L3310.25 1322.08L3304.97 1308.45L3303.52 1304.72L3299.79 1306.17L3290.27 1309.86Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M3306.37 1337.54L3302.39 1327.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M3253.27 1357.27L3266.89 1351.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M3245.49 1327.22L3241.76 1328.67L3243.2 1332.4L3248.49 1346.03L3249.93 1349.76L3253.66 1348.31L3263.18 1344.62L3266.91 1343.18L3265.46 1339.45L3260.18 1325.82L3258.73 1322.09L3255 1323.53L3245.49 1327.22Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M3261.77 1354.83L3257.79 1344.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M3222.67 1369.13L3236.29 1363.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M3215.07 1339.01L3211.34 1340.46L3212.78 1344.19L3218.07 1357.82L3219.51 1361.55L3223.24 1360.1L3232.76 1356.41L3236.49 1354.96L3235.04 1351.23L3229.76 1337.61L3228.31 1333.88L3224.59 1335.32L3215.07 1339.01Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M3231.17 1366.7L3227.19 1356.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M3179 1386.06L3192.62 1380.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M3171.21 1356.02L3167.48 1357.46L3168.93 1361.19L3174.21 1374.82L3175.66 1378.55L3179.39 1377.1L3188.91 1373.41L3192.64 1371.97L3191.19 1368.24L3185.91 1354.61L3184.46 1350.88L3180.73 1352.33L3171.21 1356.02Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M3187.5 1383.63L3183.52 1373.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M3154.55 1395.54L3168.18 1390.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M3146.95 1365.42L3143.22 1366.87L3144.67 1370.6L3149.95 1384.23L3151.4 1387.96L3155.13 1386.51L3164.65 1382.82L3168.38 1381.37L3166.93 1377.64L3161.65 1364.02L3160.2 1360.29L3156.47 1361.73L3146.95 1365.42Z",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M3163.05 1393.11L3159.07 1382.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-399-outside-5_899_2074",
    maskUnits: "userSpaceOnUse",
    x: 2866.67,
    y: 1271.26,
    width: 517.713,
    height: 287.065,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2866.67,
    y: 1271.26,
    width: 517.713,
    height: 287.065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380.31 1364.93L3023.32 1503.33C3023.32 1503.33 2956.8 1533.84 2931.1 1525.12C2905.39 1516.41 2887.65 1503.31 2877.01 1454.83"
  }))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M3023.32 1503.33L3020.43 1495.87L3020.21 1495.95L3019.99 1496.06L3023.32 1503.33ZM3377.42 1357.47L3020.43 1495.87L3026.21 1510.79L3383.21 1372.38L3377.42 1357.47ZM3023.32 1503.33C3019.99 1496.06 3019.99 1496.05 3019.99 1496.05C3019.99 1496.05 3019.99 1496.05 3019.99 1496.05C3019.99 1496.06 3019.99 1496.06 3019.98 1496.06C3019.98 1496.06 3019.97 1496.06 3019.95 1496.07C3019.93 1496.08 3019.88 1496.1 3019.83 1496.13C3019.71 1496.18 3019.53 1496.26 3019.3 1496.37C3018.82 1496.58 3018.12 1496.89 3017.21 1497.29C3015.39 1498.09 3012.75 1499.22 3009.49 1500.56C3002.97 1503.23 2994.03 1506.7 2984.35 1509.9C2974.62 1513.1 2964.33 1515.96 2955.04 1517.5C2945.47 1519.09 2938.14 1519.06 2933.67 1517.55L2928.53 1532.7C2936.91 1535.54 2947.53 1534.97 2957.66 1533.29C2968.08 1531.56 2979.23 1528.43 2989.35 1525.09C2999.51 1521.75 3008.81 1518.13 3015.56 1515.36C3018.95 1513.97 3021.7 1512.79 3023.62 1511.95C3024.58 1511.53 3025.33 1511.2 3025.84 1510.97C3026.1 1510.85 3026.3 1510.76 3026.44 1510.7C3026.51 1510.67 3026.56 1510.64 3026.6 1510.63C3026.61 1510.62 3026.63 1510.61 3026.64 1510.61C3026.64 1510.6 3026.65 1510.6 3026.65 1510.6C3026.65 1510.6 3026.65 1510.6 3026.66 1510.6C3026.66 1510.6 3026.66 1510.6 3023.32 1503.33ZM2933.67 1517.55C2921.46 1513.41 2912.12 1508.56 2904.47 1499.67C2896.69 1490.64 2890 1476.69 2884.82 1453.11L2869.2 1456.54C2874.66 1481.45 2882.16 1498.28 2892.34 1510.11C2902.64 1522.07 2915.02 1528.12 2928.53 1532.7L2933.67 1517.55Z",
    fill: "#9C9C9C",
    mask: "url(#path-399-outside-5_899_2074)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M3295.42 1396.76L3283.27 1360.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M3280.3 1402.62L3268.16 1366.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M3255.85 1412.1L3243.71 1375.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M3240.55 1418.03L3228.41 1381.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M3218.72 1426.5L3206.57 1390.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M3203.42 1432.43L3191.27 1396.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M3178.97 1441.91L3166.82 1405.6",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M3163.85 1447.77L3151.71 1411.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M3146.5 1454.5L3134.36 1418.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.2 1460.43L3119.05 1424.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M3106.94 1469.83L3094.79 1433.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M3091.63 1475.77L3079.49 1439.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M3072.79 1483.07L3060.64 1446.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M3057.48 1489.01L3045.34 1452.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M3017.92 1504.35L3010.73 1442.07",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M2998.89 1511.72L2991.31 1444.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M2981.91 1518.31L2972.69 1444.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M2965.63 1518.39L2958.05 1450.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M2948.64 1524.98L2939.43 1450.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M2926.57 1524.51L2919.33 1449.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M2890.91 1490.67L3024.58 1479.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.53 994.671L3131.53 994.671L3155.99 1234.94L3156.04 1235.47L3156.24 1235.98L3159.97 1234.53C3156.24 1235.98 3156.24 1235.98 3156.24 1235.99L3156.25 1236L3156.26 1236.03C3156.26 1236.05 3156.27 1236.06 3156.28 1236.08C3156.3 1236.12 3156.31 1236.16 3156.33 1236.2C3156.37 1236.28 3156.41 1236.37 3156.46 1236.47C3156.56 1236.67 3156.69 1236.89 3156.86 1237.12C3157.19 1237.6 3157.66 1238.14 3158.3 1238.66C3159.6 1239.73 3161.46 1240.62 3164.04 1241.05C3169.07 1241.88 3177.1 1240.98 3190.32 1235.86C3203.36 1230.8 3212.44 1226.85 3218.28 1224.15C3221.2 1222.8 3223.31 1221.77 3224.7 1221.06C3225.4 1220.71 3225.92 1220.43 3226.27 1220.25C3226.44 1220.16 3226.57 1220.08 3226.67 1220.03C3226.71 1220.01 3226.75 1219.99 3226.77 1219.97L3226.8 1219.96L3226.81 1219.95L3226.82 1219.95L3226.82 1219.95C3226.82 1219.95 3226.82 1219.95 3224.87 1216.46L3226.82 1219.95L3229.9 1218.23L3228.58 1214.96L3140.71 996.468L3202.09 971.457L3205.64 970.007L3204.34 966.394L3200.58 967.752C3204.34 966.394 3204.34 966.393 3204.34 966.392L3204.34 966.387L3204.33 966.369L3204.31 966.299L3204.2 966.019C3204.11 965.773 3203.98 965.407 3203.81 964.929C3203.46 963.973 3202.95 962.569 3202.3 960.772C3200.99 957.18 3199.1 952.02 3196.79 945.748C3192.17 933.204 3185.85 916.21 3179.06 898.408C3172.26 880.61 3164.99 861.986 3158.46 846.19C3151.97 830.49 3146.12 817.317 3142.17 810.608L3142.16 810.597L3142.16 810.586C3140.13 807.196 3138.15 804.594 3136.15 802.754C3134.16 800.917 3131.93 799.634 3129.46 799.367C3124.22 798.798 3120.91 802.883 3119.17 805.892C3117.27 809.191 3116.01 813.236 3115.23 816.261C3114.84 817.811 3114.55 819.171 3114.36 820.148C3114.27 820.638 3114.2 821.034 3114.15 821.312C3114.13 821.452 3114.11 821.562 3114.1 821.64L3114.08 821.732L3114.08 821.76L3114.08 821.769L3114.07 821.772C3114.07 821.773 3114.07 821.775 3118.03 822.377L3114.07 821.775L3114 822.277L3114.05 822.782L3131.53 994.671Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M3293.54 1189.84L3225.06 1216.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M3284.06 1165.38L3215.57 1191.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M3272.19 1134.76L3203.71 1161.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M3262.78 1110.49L3194.3 1137.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M3248.6 1073.9L3180.11 1100.45",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M3239.12 1049.45L3170.63 1076",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M3226.67 1017.34L3158.18 1043.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M3217.19 992.882L3148.7 1019.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M2032.11 935.785L2007.61 870.785L2317.61 751.785L2342.11 815.785L2032.11 935.785Z",
    fill: "#6CDD59"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.11 1513.79L1142.61 1447.29L1357.61 1363.79L1383.61 1430.29L1167.11 1513.79Z",
    fill: "#6CDD59"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M759.609 2072.79L738.109 2015.29L759.609 2006.79L781.609 2064.79L759.609 2072.79Z",
    fill: "#FE763B"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.11 909.785L1496.61 845.785L1589.11 785.785L1626.11 845.785L1535.11 909.785Z",
    fill: "#6CDD59"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M110.195 1977.95L272.076 1741.04L537.038 1499.8L1268.43 995.496L2185.46 391.948L2956.81 4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M882.034 1787.12L858.751 1725.8L886.623 1715.4L910.418 1775.72L882.034 1787.12Z",
    fill: "#6CDD59"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M857.707 1796.54L834.425 1735.22L854.188 1727.79L877.98 1788.61L857.707 1796.54Z",
    fill: "#6CDD59"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M828.822 1807.44L805.026 1747.12L830.364 1737.72L853.654 1798.03L828.822 1807.44Z",
    fill: "#6CDD59"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.54 1729.65L1006.26 1664.78L1026.03 1656.84L1051.81 1721.72L1031.54 1729.65Z",
    fill: "#6CDD59"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.11 1698.92L1087.82 1637.6L1115.19 1627.2L1138.98 1687.51L1111.11 1698.92Z",
    fill: "#6CDD59"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.08 1656.3L1197.8 1595.49L1225.17 1584.08L1248.45 1645.4L1221.08 1656.3Z",
    fill: "#6CDD59"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.06 1613.69L1305.79 1548.31L1333.66 1537.4L1357.92 1602.77L1331.06 1613.69Z",
    fill: "#FF1717"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M1388.8 1595.94L1412.09 1655.74L1438.96 1644.83L1415.66 1585.53L1388.8 1595.94Z",
    fill: "#6CDD59"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.99 1576.11L1420.22 1584.05L1445 1647.91L1464.76 1640.48L1439.99 1576.11Z",
    fill: "#6CDD59"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.33 1638.49L1444.55 1574.63L1471.91 1564.23L1497.2 1627.59L1469.33 1638.49Z",
    fill: "#6CDD59"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M409.152 1974.53L382.796 1984.94L408.073 2049.81L434.428 2039.4L409.152 1974.53Z",
    fill: "#EEEEEE"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M438.983 2038.43L413.71 1973.05L433.983 1965.12L458.75 2030.49L438.983 2038.43Z",
    fill: "#6CDD59"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M772.994 1905.55L749.222 1842.2L769.491 1834.78L794.783 1897.63L772.994 1905.55Z",
    fill: "#FF1717"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M803.172 1747.74L853.473 1877.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M722.182 1779.14L772.482 1908.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M778.727 1757.21L829.027 1886.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M746.627 1769.66L796.928 1899.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M1269.61 1960.29L1218.61 1832.29L1826.61 1597.79L1876.61 1725.29L1269.61 1960.29Z",
    fill: "#6CDD59"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.61 1897.29L1407.11 1827.79L1435.61 1816.79L1462.61 1885.79L1433.61 1897.29Z",
    fill: "#FF1717"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.61 1776.79L1718.11 1707.29L1738.11 1699.79L1765.61 1768.79L1744.61 1776.79Z",
    fill: "#FF1717"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.61 1423.29L1168.11 1360.29L1222.11 1340.29L1245.61 1402.79L1191.61 1423.29Z",
    fill: "#6CDD59"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M914.609 1608.29L889.609 1545.29L1058.11 1479.29L1082.61 1543.79L914.609 1608.29Z",
    fill: "#6CDD59"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M1941.11 1848.79L1920.11 1795.29L2199.61 1686.79L2218.61 1741.79L1941.11 1848.79Z",
    fill: "#6CDD59"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M2388.61 1676.29L2368.11 1619.79L2586.11 1539.29L2604.61 1590.79L2388.61 1676.29Z",
    fill: "#6CDD59"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.61 1236.29L1653.61 1174.79L1947.61 1061.79L1970.61 1124.29L1675.61 1236.29Z",
    fill: "#6CDD59"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M752.609 1429.29L719.109 1374.29L962.609 1206.79L999.109 1265.79L752.609 1429.29Z",
    fill: "#6CDD59"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.11 918.285L1848.61 858.285L1921.61 829.785L1944.11 890.285L1872.11 918.285Z",
    fill: "#6CDD59"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M2006.11 867.285L1982.61 807.785L2149.11 741.285L2173.11 803.285L2006.11 867.285Z",
    fill: "#6CDD59"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M2319.11 746.785L2297.11 684.785L2403.61 644.285L2428.11 705.285L2319.11 746.785Z",
    fill: "#6CDD59"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M1755.61 963.285L1735.61 905.285L1788.61 882.785L1811.61 941.285L1755.61 963.285Z",
    fill: "#6CDD59"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.11 1411.29L1394.11 1349.79L1471.61 1319.79L1495.11 1381.79L1418.11 1411.29Z",
    fill: "#6CDD59"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M1555.11 1362.79L1530.11 1297.29L1642.61 1253.79L1667.61 1319.79L1555.11 1362.79Z",
    fill: "#6CDD59"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M3070.11 405.285L2983.11 176.785L3055.11 147.785L3142.11 379.785L3070.11 405.285Z",
    fill: "#6CDD59"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M2173.11 1120.79L2148.11 1057.79L2451.61 940.785L2478.11 1007.36L2173.11 1120.79Z",
    fill: "#6CDD59"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M2226.11 1100.79L2202.11 1036.79L2230.61 1025.79L2254.61 1090.29L2226.11 1100.79Z",
    fill: "#FF1717"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M2189.11 1520.29L2168.11 1463.79L2475.61 1344.29L2499.11 1401.79L2189.11 1520.29Z",
    fill: "#6CDD59"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M1622.61 1971.29L1603.11 1919.79L1890.11 1807.29L1909.61 1861.79L1622.61 1971.29Z",
    fill: "#6CDD59"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M332.109 1771.79L290.609 1724.79L536.609 1501.29L572.609 1554.29L332.109 1771.79Z",
    fill: "#6CDD59"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M815.609 2285.29L795.109 2234.79L935.109 2179.29L957.109 2229.79L815.609 2285.29Z",
    fill: "#6CDD59"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M2918.11 623.285L2902.61 472.785H2985.61L3000.61 618.785L2918.11 623.285Z",
    fill: "#6CDD59"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M3125.11 544.785L3094.11 465.285L3164.61 436.785L3195.11 515.785L3125.11 544.785Z",
    fill: "#6CDD59"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M3180.11 686.785L3251.61 657.285L3295.11 771.785L3224.11 801.285L3180.11 686.785Z",
    fill: "#6CDD59"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M2026.11 1662.79L2001.11 1598.29L2052.61 1577.79L2076.61 1641.79L2026.11 1662.79Z",
    fill: "#6CDD59"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M1750.61 1043.29L1726.11 981.785L1732.61 979.285L1732.11 976.785L1980.61 881.285L2005.61 946.285L1750.61 1043.29Z",
    fill: "#6CDD59"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M430.609 2548.79L406.109 2483.29L827.109 2321.29L851.609 2381.29L430.609 2548.79Z",
    fill: "#6CDD59"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.61 843.285L1593.11 782.285L1743.61 684.285L1777.61 749.285L1627.61 843.285Z",
    fill: "#6CDD59"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M2676.11 217.785L2650.11 158.285L2927.11 18.2852L2953.61 86.2852L2676.11 217.785Z",
    fill: "#6CDD59"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M2326.11 1546.29L2301.11 1482.29L2469.11 1416.79L2494.11 1482.29L2326.11 1546.29Z",
    fill: "#6CDD59"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.61 1366.79L1313.61 1309.29L1534.11 1223.79L1557.61 1282.29L1335.61 1366.79Z",
    fill: "#6CDD59"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M2961.11 796.285L2940.11 740.785H3026.11L3071.11 1064.29L2989.61 1067.29L2961.11 796.285Z",
    fill: "#6CDD59"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.61 2089.29L1297.61 2032.29L1406.11 1991.79L1426.11 2048.29L1318.61 2089.29Z",
    fill: "#6CDD59"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.61 1909.79L1160.11 1854.79L1190.11 1842.29L1211.61 1897.79L1182.61 1909.79Z",
    fill: "#FF1717"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M2425.11 1190.29L2403.11 1133.79L2480.61 1104.79L2502.11 1160.79L2425.11 1190.29Z",
    fill: "#FF1717"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M1481.61 942.785L1446.61 879.785L1494.11 848.285L1530.61 910.785L1481.61 942.785Z",
    fill: "#FF1717"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M2449.61 1181.29L2427.61 1124.29L2455.61 1113.79L2477.61 1170.29L2449.61 1181.29Z",
    fill: "#6CDD59"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M1633.61 1573.79L1610.11 1510.79L1641.11 1498.29L1665.61 1562.29L1633.61 1573.79Z",
    fill: "#FE763B"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M770.609 1660.29L748.109 1601.79L771.609 1592.79L793.609 1651.29L770.609 1660.29Z",
    fill: "#FF1717"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.61 1486.29L1004.61 1424.29L1032.11 1414.29L1055.61 1476.29L1028.61 1486.29Z",
    fill: "#FE763B"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M2066.61 1084.79L2042.11 1021.79L2062.11 1014.29L2086.11 1077.29L2066.61 1084.79Z",
    fill: "#FE763B"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M2345.11 737.285L2321.11 675.285L2346.11 665.785L2369.61 727.785L2345.11 737.285Z",
    fill: "#FE763B"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.37 1657.64L1710.6 1787.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.55 1667.26L1685.78 1796.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M1603.08 1679.85L1653.31 1809.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.26 1689.47L1628.49 1819.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M1886.58 1574.45L1936.88 1704.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M1861.76 1584.08L1912.06 1713.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M1829.29 1596.66L1879.59 1726.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1804.65 1606.21L1854.95 1735.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M1775.17 1617.64L1825.47 1747.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M1750.54 1627.2L1800.84 1756.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M1718.06 1639.79L1768.37 1769.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.24 1649.41L1743.54 1779.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M1554.03 1703.38L1604.33 1833.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M1528.84 1713.14L1579.14 1842.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M1495.62 1726.02L1545.92 1855.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.43 1735.79L1520.73 1865.53",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.57 1747.37L1490.87 1877.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.19 1757.2L1465.49 1886.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.16 1770.01L1432.46 1899.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.97 1779.78L1407.27 1909.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.35 1788.3L1373.58 1917.86",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.16 1798.07L1348.39 1927.63",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.94 1810.95L1315.17 1940.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.75 1820.71L1289.98 1950.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.43 1339.74L1272.73 1469.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.99 1349.22L1248.29 1478.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.89 1361.66L1216.19 1491.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.63 1371.07L1191.93 1500.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.79 1424.89L1053.09 1554.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M978.344 1434.37L1028.64 1564.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M946.434 1446.74L996.734 1576.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M921.986 1456.22L972.287 1585.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M886.902 1469.82L937.203 1599.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M862.457 1479.3L912.758 1609.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M830.359 1491.74L880.66 1621.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M830.779 1564.81L856.4 1630.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.61 1058.29L1269.11 996.285L1316.11 965.785L1350.61 1027.79L1303.61 1058.29Z",
    fill: "#6CDD59"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.52 1058.69L1273.09 1008.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.18 1042.95L1294.34 984.812",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.85 1027.2L1320.08 969.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.35 1008.64L1343.51 950.504",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.42 993.931L1372.65 935.984",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M2005.7 1038.44L2056 1168.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M1981.25 1047.92L2031.55 1177.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M1620.9 1188.71L1669.62 1318.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M1654.57 1175L1703.28 1305.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1688.24 1161.28L1736.95 1291.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1721.91 1147.57L1770.62 1277.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M1755.58 1133.85L1804.29 1263.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.25 1120.14L1837.96 1250.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M1826.57 1106L1875.28 1236.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M1864.57 1093L1913.28 1223.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M1901.57 1080L1950.28 1210.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.57 1062L1995.28 1192.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.47 1198.26L1642.71 1329.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M1918.73 1793.05L1950.71 1880.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M1947.28 1781.98L1979.45 1869.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M1974.17 1773.28L2006.41 1860.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M2002.73 1762.21L2034.96 1849.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M2023.46 1755.89L2055.69 1843.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M2052.2 1744.74L2084.25 1832.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M2085.98 1731.65L2118.21 1819.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M2114.71 1720.51L2146.76 1808.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M2144.91 1705.37L2176.88 1792.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M2173.46 1694.3L2205.62 1781.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M2200.35 1685.59L2232.58 1773.17",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M2228.9 1674.52L2261.14 1762.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M2249.64 1668.2L2281.87 1755.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M2278.37 1657.06L2310.42 1744.71",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M2312.34 1643.89L2344.38 1731.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M2340.89 1632.82L2373.12 1720.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M2365.3 1619.93L2397.46 1707.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M2393.85 1608.85L2426.01 1696.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M2420.74 1600.15L2452.97 1687.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M2449.29 1589.08L2481.53 1676.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M2470.21 1582.69L2502.45 1670.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M2498.76 1571.62L2531 1659.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M2532.73 1558.45L2564.96 1646.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M2561.28 1547.38L2593.51 1634.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M679.149 1484.87L648.818 1435.43",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M704.193 1468.07L669.143 1411.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M729.31 1451.46L694.188 1394.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M752.003 1431.93L716.881 1375.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M780.642 1416.1L745.52 1359.29",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M803.786 1403.26L773.455 1353.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M828.644 1386.54L793.521 1329.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M853.687 1369.75L818.637 1313.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M876.568 1350.14L841.518 1293.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M905.091 1334.57L869.969 1277.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M928.497 1317.98L898.166 1268.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M953.54 1301.18L918.49 1244.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M978.658 1284.58L943.535 1227.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.35 1265.04L966.229 1208.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.99 1249.21L994.867 1192.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M1756.17 894.238L1806.4 1023.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M1731.72 903.719L1781.95 1033.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M1699.81 916.09L1750.04 1045.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.37 925.566L1725.59 1055.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M1870.56 849.887L1920.79 979.446",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.12 859.367L1896.35 988.926",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.21 871.738L1864.44 1001.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.76 881.215L1839.99 1010.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M1980.29 807.348L2030.52 936.907",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M1956.03 816.754L2006.26 946.313",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.93 829.199L1974.16 958.758",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M1899.49 838.676L1949.72 968.235",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.37 762.348L2146.59 891.907",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M2071.92 771.824L2122.15 901.383",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M2039.82 784.27L2090.05 913.829",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M2015.38 793.746L2065.6 923.305",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M2206.09 719.809L2256.32 849.368",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M2181.65 729.289L2231.88 858.848",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M2149.74 741.66L2199.97 871.219",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M2125.29 751.137L2175.52 880.696",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M2319 676.039L2369.22 805.598",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M2294.55 685.52L2344.78 815.079",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M2262.45 697.961L2312.68 827.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M2238.19 707.367L2288.42 836.926",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M2428.72 633.496L2478.95 763.055",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M2404.46 642.902L2454.69 772.462",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M2372.37 655.348L2422.59 784.907",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M2347.92 664.824L2398.15 794.383",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.68 1252.41L1497.98 1382.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M1423.23 1261.89L1473.53 1391.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.13 1274.34L1441.43 1404.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.87 1283.74L1417.17 1413.49",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.05 1213.19L1611.35 1342.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M1536.6 1222.67L1586.9 1352.41",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M1504.69 1235.04L1554.99 1364.78",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.25 1244.52L1530.55 1374.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M3036.94 319.75L3107.86 291.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M3048.37 349.246L3119.3 320.676",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M3059.44 377.808L3130.37 349.238",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M3070.88 407.305L3141.8 378.734",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M3081.16 433.815L3152.01 405.059",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M3092.59 463.312L3163.44 434.555",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-625-outside-6_899_2074",
    maskUnits: "userSpaceOnUse",
    x: 2966.16,
    y: 108.883,
    width: 530.219,
    height: 1191.9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2966.16,
    y: 108.883,
    width: 530.219,
    height: 1191.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2970.71 148.933L3041.64 120.363L3488.41 1272.77"
  }))), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M3041.64 120.363L3049.09 117.471L3046.16 109.914L3038.65 112.943L3041.64 120.363ZM2973.7 156.354L3044.62 127.784L3038.65 112.943L2967.72 141.513L2973.7 156.354ZM3034.18 123.255L3480.95 1275.66L3495.87 1269.88L3049.09 117.471L3034.18 123.255Z",
    fill: "#9C9C9C",
    mask: "url(#path-625-outside-6_899_2074)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M2982.15 178.43L3053.07 149.859",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M2993.22 206.991L3064.07 178.234",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M3004.65 236.487L3075.51 207.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M3014.86 262.812L3085.78 234.242",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M3026.3 292.308L3097.22 263.738",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M2453.81 867.078L2504.11 996.824",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M2429.36 876.559L2479.66 1006.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M2397.45 888.93L2447.75 1018.68",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M2373 898.406L2423.3 1028.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.08 909.617L2394.38 1039.36",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M2319.63 919.098L2369.93 1048.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M2287.54 931.539L2337.84 1061.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M2263.28 940.945L2313.58 1070.69",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M2230.52 948.918L2280.82 1078.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M2206.26 958.324L2256.56 1088.07",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M2174.16 970.77L2224.46 1100.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M2149.71 980.246L2200.02 1109.99",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.88 1806.4L1000.59 1746.59L1218.02 1661.33L1241.31 1721.64L1023.88 1806.4Z",
    fill: "#EEEEEE"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.31 1655.73L1078.61 1785.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.87 1665.2L1054.17 1794.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M971.77 1677.65L1022.07 1807.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M947.322 1687.12L997.623 1816.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M1583.03 1445.39L1633.33 1575.14",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M1558.58 1454.88L1608.88 1584.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M1526.48 1467.32L1576.78 1597.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.22 1476.72L1552.52 1606.47",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.11 1488.01L1523.41 1617.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.85 1497.41L1499.15 1627.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.76 1509.86L1467.06 1639.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.31 1519.34L1442.61 1649.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.81 1591.88L1362.04 1527.01L1389.91 1517.11L1414.18 1580.97L1386.81 1591.88Z",
    fill: "#6CDD59"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.82 1549.28L1475.02 1487.95L1500.37 1477.53L1524.15 1538.86L1499.82 1549.28Z",
    fill: "#6CDD59"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.54 1527.45L1528.75 1466.63L1556.62 1456.23L1579.9 1517.05L1552.54 1527.45Z",
    fill: "#6CDD59"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.76 1492.78L1621.95 1436.52L1641.72 1428.58L1664.04 1484.34L1643.76 1492.78Z",
    fill: "#6CDD59"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M2602.11 766.285L2570.11 435.285L2622.61 430.785L2661.11 760.285L2602.11 766.285Z",
    fill: "#6CDD59"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M2569.6 435.434L2665.59 427.212",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M2574.04 461.844L2669.84 453.694",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M2574.85 494.387L2670.77 485.978",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M2578.9 523.094L2674.89 514.872",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M2591.49 676.266L2687.47 668.044",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M2595.93 702.672L2691.85 694.263",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M2596.86 734.957L2692.65 726.807",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M2600.97 763.852L2696.96 755.629",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M2579.1 553.508L2675.09 545.286",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M2583.54 579.918L2679.34 571.768",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M2584.28 612.273L2680.27 604.051",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M2588.4 641.168L2684.39 632.946",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M3289.61 966.285L3360.11 938.285L3469.61 1217.29L3396.11 1246.29L3289.61 966.285Z",
    fill: "#6CDD59"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M3296.47 989.202L3367.33 960.445",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M3307.91 1018.7L3378.76 989.941",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M3318.91 1047.07L3389.83 1018.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M3330.34 1076.57L3401.27 1048",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M3340.62 1103.08L3411.47 1074.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M3352.06 1132.58L3422.91 1103.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M3361.9 1157.96L3432.83 1129.39",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M3373.34 1187.46L3444.26 1158.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M3384.41 1216.02L3455.26 1187.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M3466.7 1216.76L3395.84 1245.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M3406.05 1271.84L3476.97 1243.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M3417.48 1301.34L3488.41 1272.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M3232.57 824.359L3303.49 795.789",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M3244 853.855L3314.93 825.285",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M3255.07 882.417L3325.93 853.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M3266.51 911.913L3337.36 883.156",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M3276.72 938.238L3347.64 909.668",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M3288.15 967.734L3359.08 939.164",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M2221.53 1442.88L2271.83 1572.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M2197.08 1452.36L2247.38 1582.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M2165.17 1464.73L2215.47 1594.48",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M2140.72 1474.21L2191.03 1603.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M2111.8 1485.42L2162.1 1615.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M2087.54 1494.82L2137.84 1624.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M2055.44 1507.27L2105.74 1637.01",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M2031.18 1516.67L2081.48 1646.42",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M1998.61 1524.57L2048.91 1654.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M1974.17 1534.05L2024.47 1663.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M1942.25 1546.43L1992.55 1676.17",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M1917.81 1555.9L1968.11 1685.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M2502.38 1334L2552.68 1463.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M2477.37 1343.69L2527.67 1473.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M2447.7 1355.2L2498 1484.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M2422.7 1364.89L2473 1494.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M2389.85 1377.62L2440.15 1507.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M2364.85 1387.32L2415.15 1517.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M2331.53 1395.51L2381.83 1525.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M2306.52 1405.2L2356.82 1534.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M2273.87 1417.86L2324.17 1547.61",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M2248.86 1427.56L2299.16 1557.3",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.62 1967.55L1500.78 2054.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M1497.36 1956.41L1529.52 2043.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M1524.25 1947.71L1556.48 2035.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.8 1936.64L1585.04 2024.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M1573.53 1930.32L1605.77 2017.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.09 1919.25L1634.32 2006.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.05 1906.08L1668.28 1993.65",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M1664.79 1894.94L1696.84 1982.58",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.77 1878.34L1726.01 1965.91",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M1722.32 1867.26L1754.56 1954.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M1749.29 1858.75L1781.45 1946.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M1778.03 1847.6L1810 1935.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.76 1841.28L1830.99 1928.86",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M1827.31 1830.21L1859.55 1917.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M1861.27 1817.05L1893.51 1904.62",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M1889.83 1805.98L1922.06 1893.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M865.609 2114.79L815.609 1984.79L1076.61 1887.29L1126.11 2013.29L865.609 2114.79Z",
    fill: "#6CDD59"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M869.994 1963.84L920.223 2093.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M845.734 1973.25L895.963 2102.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M813.639 1985.69L863.867 2115.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M789.191 1995.17L839.42 2124.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M760.266 2006.38L810.494 2135.94",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M735.82 2015.86L786.049 2145.42",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M703.91 2028.23L754.139 2157.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M679.463 2037.71L729.691 2167.27",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M662.111 2040.57L712.34 2170.13",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M631.723 2053L682.023 2182.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M590.35 2067.54L640.65 2197.28",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M565.902 2077.01L616.203 2206.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.15 1831.62L1267.37 1961.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.95 1841.39L1242.18 1970.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.74 1854.27L1208.96 1983.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.54 1864.04L1183.77 1993.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M986.018 1916.5L1036.32 2046.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M960.826 1926.27L1011.13 2056.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M927.609 1939.15L977.91 2068.89",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M902.416 1948.91L952.717 2078.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.5 1875.68L1153.73 2005.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.12 1885.52L1128.35 2015.08",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.09 1898.32L1095.32 2027.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.71 1908.16L1069.94 2037.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M263.564 2267.24L2556.9 1380.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M1976.11 615.785L1942.11 551.785L2192.11 388.785L2407.11 281.285L2433.61 344.785L1976.11 615.785Z",
    fill: "#6CDD59"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M2302.71 411.992L2279.36 358.98",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M2329.2 398.928L2302.3 337.848",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M2355.8 385.609L2328.97 324.715",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M2380.62 369.331L2353.72 308.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M2410.59 357.496L2383.76 296.602",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M2176.89 486.109L2148.91 435.539",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M2202.18 470.507L2169.59 412.488",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M2227.47 454.902L2194.88 396.883",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.52 436.302L2218.13 378.211",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M2279.22 421.74L2246.83 363.648",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M2051.82 569.383L2023.84 518.812",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M2077.04 553.591L2044.64 495.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M2102.33 537.988L2069.75 479.969",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M2125.39 519.388L2092.99 461.297",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M2154.16 505.012L2121.69 446.734",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M1925.72 649.409L1897.67 598.652",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M1950.93 633.62L1918.35 575.602",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M1976.22 618.015L1943.64 559.996",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M1999.28 599.416L1966.88 541.324",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M2027.98 584.853L1995.59 526.762",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M330.355 1773.42L292.008 1729.88",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M307.682 1702.75L352.169 1752.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M373.722 1731.91L329.494 1682.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M392.886 1708.8L348.658 1658.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M373.965 1638.4L418.452 1688.37",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M435.488 1665.88L401.787 1618.81",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M459.25 1647.43L420.197 1593.21",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M483.01 1628.98L444.029 1574.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M504.42 1607.8L465.439 1553.76",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M531.703 1590.13L492.723 1536.1",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M550.88 1572.61L518.227 1524.92",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M575.044 1554.65L537.039 1499.8",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M599.209 1536.69L561.203 1481.85",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M621.021 1515.99L583.016 1461.15",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M648.709 1498.82L610.703 1443.97",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M823.381 2221.79L881.353 2371.32",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M849.881 2211.51L907.853 2361.05",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M882.352 2198.92L940.324 2348.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M908.85 2188.65L966.822 2338.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M2148.51 1239.05L2198.81 1368.79",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M2124.25 1248.45L2174.55 1378.2",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M2092.16 1260.9L2142.46 1390.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M2067.71 1270.38L2118.01 1400.12",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M2035.14 1278.28L2085.44 1408.02",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M2010.7 1287.76L2061 1417.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M1978.79 1300.13L2029.09 1429.87",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M1954.34 1309.61L2004.64 1439.35",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M2202.07 1218.29L2252.37 1348.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M2177.63 1227.76L2227.93 1357.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M2254.11 1346.79L2226.11 1272.79L2335.11 1230.29L2364.11 1303.29L2254.11 1346.79Z",
    fill: "#6CDD59"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M2258.43 1196.43L2308.73 1326.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M2233.98 1205.91L2284.29 1335.66",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M2510.99 1092.08L2561.29 1221.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M2482.06 1103.29L2532.36 1233.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M2457.61 1112.77L2507.91 1242.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M2425.52 1125.21L2475.82 1254.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M2401.07 1134.69L2451.37 1264.44",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M2368.5 1142.59L2418.8 1272.34",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.05 1152.07L2394.36 1281.82",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M2312.14 1164.45L2362.45 1294.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M2287.7 1173.92L2338 1303.67",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M2891.6 387.262L2974.33 384.176",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M2896.79 413.383L2979.52 410.297",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M2899.2 445.086L2981.75 442.073",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M2904.25 473.621L2986.99 470.536",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M2903.49 503.766L2986.04 500.753",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M2908.49 529.961L2991.23 526.876",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M2910.91 561.664L2993.65 558.579",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M2916.15 590.125L2998.88 587.04",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M3102.43 488.698L3173.29 459.941",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M3113.87 518.194L3184.72 489.438",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M3124.87 546.57L3195.79 518",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M3136.31 576.066L3207.23 547.496",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M3146.58 602.574L3217.51 574.004",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M3158.02 632.07L3228.94 603.5",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M3167.86 657.461L3238.79 628.891",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M3179.3 686.957L3250.22 658.387",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M3190.37 715.519L3261.22 686.762",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M3201.81 745.015L3272.73 716.445",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M3212.08 771.526L3282.93 742.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M3223.52 801.022L3294.37 772.266",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.81 1300.51L1386.11 1430.26",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.36 1309.99L1361.66 1439.74",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M1279.45 1322.36L1329.75 1452.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M1255 1331.84L1305.3 1461.59",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M374.055 2399.42L432.027 2548.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M405.594 2387.19L463.566 2536.73",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M435.836 2374.39L493.808 2523.93",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M452.07 2368.1L510.043 2517.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M476.879 2359.55L534.851 2509.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M504.883 2347.62L562.855 2497.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M524.289 2340.1L582.262 2489.64",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M550.926 2327.41L608.898 2476.95",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M577.924 2315.66L635.896 2465.19",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M621.914 2296.24L679.887 2445.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M647.729 2287.52L705.701 2437.06",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M669.688 2277.72L727.66 2427.25",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M694.93 2270.3L752.902 2419.83",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M724.414 2258.86L782.387 2408.4",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M744.756 2250.98L802.728 2400.51",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M767.76 2244.42L825.732 2393.96",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M792.963 2233.58L850.935 2383.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M1551.92 893.967L1523.76 843.469",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M1577.21 878.362L1544.56 820.156",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.43 862.574L1569.85 804.555",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M1625.56 844.157L1593.09 785.879",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M1654.26 829.594L1621.79 771.316",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.03 813.941L1650.05 763.371",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M1703.32 798.338L1670.66 740.133",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.54 782.546L1695.96 724.527",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M1780.37 749.571L1747.9 691.293",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M1751.67 764.133L1719.2 705.855",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M2710.51 206.434L2689.03 152.699",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M2737.48 194.045L2712.63 132.168",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M2764.52 181.845L2739.67 119.969",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M2789.81 166.241L2765.03 104.551",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M2820.21 155.529L2795.37 93.6523",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M2845.06 139.881L2823.77 86.0742",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M2872.1 127.681L2847.25 65.8047",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M2899.25 115.221L2874.48 53.5312",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M2924.62 99.8024L2899.77 37.9258",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M2954.84 89.1617L2929.99 27.2852",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M2943.72 742.637L3026.46 739.551",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M2948.91 768.758L3031.65 765.672",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M2951.4 800.648L3034.06 797.376",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M2956.38 828.996L3039.12 825.911",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M2966.57 860.266L3049.3 857.18",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M2971.69 886.199L3054.42 883.114",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M2974.17 918.09L3056.91 915.004",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M2979.23 946.625L3061.96 943.54",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M2977.03 982.48L3059.76 979.395",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M2982.22 1008.6L3064.95 1005.52",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M2984.63 1040.3L3067.37 1037.22",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M2989.69 1068.84L3072.42 1065.75",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M2960.84 956.088L2960.76 956.146L2960.69 956.209C2959.74 957.024 2958.16 957.078 2956.94 955.822C2950.12 948.325 2938.38 953.564 2937.89 963.046L2937.88 963.171L2937.88 963.296C2937.9 964.481 2936.75 965.9 2935.17 966.037C2925.51 966.805 2921.23 979.095 2929.13 985.361C2930.48 986.491 2930.6 988.182 2929.84 989.262L2929.82 989.291L2929.8 989.32C2924.26 997.502 2931.39 1008.28 2941.1 1006.23C2942.56 1005.93 2944.04 1006.75 2944.56 1008.35C2947.51 1017.64 2960.41 1018.78 2964.8 1009.93L2964.81 1009.92L2964.81 1009.91C2965.45 1008.6 2967.17 1007.94 2968.52 1008.47L2968.53 1008.48L2968.54 1008.48C2977.76 1012.06 2986.53 1002.51 2982.42 993.645L2982.38 993.561L2982.34 993.479C2981.72 992.293 2982.1 990.632 2983.56 989.767C2992.07 984.768 2990.14 972.1 2980.66 969.696C2979 969.15 2978.14 967.726 2978.34 966.283C2979.94 956.327 2968.49 950.135 2960.84 956.088Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.73 2032.65L1327.96 2120.23",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.28 2021.58L1356.51 2109.16",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.82 2004.31L1405.8 2091.77",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.78 1991.14L1439.76 2078.6",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.53 2060.99L1376.46 2061.05L1376.39 2061.12C1375.44 2061.93 1373.85 2061.98 1372.63 2060.73C1365.82 2053.23 1354.07 2058.47 1353.58 2067.95L1353.57 2068.08L1353.58 2068.2C1353.59 2069.39 1352.44 2070.81 1350.86 2070.94C1341.21 2071.71 1336.93 2084 1344.82 2090.27C1346.17 2091.4 1346.29 2093.09 1345.53 2094.17L1345.51 2094.2L1345.49 2094.23C1339.95 2102.41 1347.09 2113.19 1356.79 2111.13C1358.25 2110.83 1359.73 2111.65 1360.26 2113.25C1363.21 2122.55 1376.1 2123.68 1380.5 2114.84L1380.5 2114.83L1380.51 2114.82C1381.15 2113.51 1382.86 2112.84 1384.22 2113.38L1384.23 2113.38L1384.24 2113.39C1393.45 2116.96 1402.22 2107.41 1398.11 2098.55L1398.07 2098.47L1398.03 2098.39C1397.41 2097.2 1397.8 2095.54 1399.25 2094.67C1407.76 2089.67 1405.83 2077.01 1396.35 2074.6C1394.69 2074.06 1393.84 2072.63 1394.03 2071.19C1395.64 2061.23 1384.18 2055.04 1376.53 2060.99Z",
    fill: "#FCFCFC",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 1776.29L1088.11 1712.29L1108.11 1704.29L1135.11 1767.79L1112.61 1776.29Z",
    fill: "#FF1717"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.61 1744.79L1168.61 1680.29L1329.61 1619.29L1353.11 1680.29L1193.61 1744.79Z",
    fill: "#6CDD59"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.41 1573.96L1301.71 1703.7",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.15 1583.36L1277.46 1713.11",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.06 1595.81L1245.36 1725.55",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.61 1605.29L1220.91 1735.03",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.74 1527.24L1410.04 1656.98",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.29 1536.72L1385.59 1666.46",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.38 1549.09L1353.68 1678.84",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.93 1558.57L1329.23 1688.31",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.69 1616.5L1191.99 1746.24",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.24 1625.98L1167.54 1755.72",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.33 1638.35L1135.63 1768.09",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.88 1647.82L1111.18 1777.57",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M1479.81 943.825L1446.96 885.691",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.31 925.266L1470.46 867.133",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M1532.57 910.487L1499.54 852.426",
    stroke: "#9C9C9C",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M2124.11 900.285L2099.11 835.785L2119.11 827.285L2144.11 892.285L2124.11 900.285Z",
    fill: "#FF1717"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M2183.11 492.785L2142.11 420.785L2163.61 406.785L2205.11 480.285L2183.11 492.785Z",
    fill: "#FF1717"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 370.477,
    y: 2591.37,
    width: 454.149,
    height: 118,
    rx: 10,
    transform: "rotate(-20.9769 370.477 2591.37)",
    fill: "#FE763B"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M477.279 2628.03L468.078 2604.3L474.521 2601.8L481.71 2620.34L491.305 2616.62L493.318 2621.81L477.279 2628.03Z",
    fill: "white"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M504.716 2617.77C502.785 2618.51 500.983 2618.77 499.312 2618.54C497.637 2618.3 496.166 2617.64 494.899 2616.55C493.629 2615.45 492.641 2613.99 491.934 2612.16C491.227 2610.34 490.974 2608.6 491.175 2606.94C491.372 2605.27 492.011 2603.79 493.089 2602.49C494.165 2601.19 495.668 2600.16 497.6 2599.41C499.531 2598.66 501.334 2598.41 503.009 2598.65C504.681 2598.88 506.152 2599.54 507.422 2600.64C508.689 2601.73 509.676 2603.19 510.383 2605.01C511.089 2606.84 511.344 2608.58 511.146 2610.25C510.945 2611.91 510.307 2613.39 509.232 2614.7C508.153 2615.99 506.648 2617.02 504.716 2617.77ZM502.93 2613.02C503.471 2612.81 503.868 2612.45 504.121 2611.93C504.374 2611.42 504.478 2610.78 504.434 2610.02C504.39 2609.27 504.188 2608.43 503.829 2607.5C503.466 2606.56 503.048 2605.81 502.574 2605.23C502.097 2604.64 501.592 2604.24 501.057 2604.03C500.522 2603.82 499.984 2603.82 499.443 2604.03C498.872 2604.25 498.451 2604.62 498.183 2605.14C497.914 2605.66 497.802 2606.3 497.846 2607.06C497.887 2607.81 498.089 2608.65 498.452 2609.58C498.811 2610.51 499.229 2611.27 499.706 2611.86C500.183 2612.45 500.697 2612.84 501.247 2613.05C501.797 2613.25 502.358 2613.24 502.93 2613.02Z",
    fill: "white"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M520.125 2590.94L521.922 2595.58L510.195 2600.13L508.398 2595.49L520.125 2590.94ZM509.016 2590.35L515.413 2587.87L521.747 2604.21C521.843 2604.45 521.966 2604.64 522.117 2604.78C522.265 2604.91 522.444 2604.98 522.655 2605C522.863 2605.01 523.106 2604.96 523.384 2604.85C523.577 2604.78 523.792 2604.67 524.029 2604.52C524.274 2604.37 524.452 2604.26 524.563 2604.18L527.234 2608.32C526.981 2608.51 526.612 2608.78 526.127 2609.11C525.649 2609.43 525.055 2609.76 524.344 2610.08C522.906 2610.72 521.615 2611.05 520.472 2611.06C519.325 2611.06 518.341 2610.74 517.518 2610.11C516.695 2609.48 516.051 2608.54 515.584 2607.29L509.016 2590.35Z",
    fill: "white"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M542.21 2602.86L535.257 2605.55L533.89 2578.78L542.697 2575.37L559.732 2596.06L552.779 2598.76L540.92 2583.58L540.734 2583.65L542.21 2602.86ZM537.282 2594L550.354 2588.93L552.223 2593.75L539.151 2598.82L537.282 2594Z",
    fill: "white"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M568.519 2592.66L559.318 2568.92L576.422 2562.29L578.435 2567.48L567.774 2571.62L569.355 2575.7L579.136 2571.91L581.149 2577.1L571.368 2580.89L572.949 2584.97L583.565 2580.85L585.577 2586.04L568.519 2592.66Z",
    fill: "white"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M588.912 2584.75L582.011 2566.95L588.083 2564.6L589.395 2567.98L589.581 2567.91C589.52 2566.65 589.812 2565.53 590.457 2564.53C591.102 2563.53 592.042 2562.8 593.278 2562.32C594.53 2561.83 595.736 2561.75 596.898 2562.06C598.056 2562.37 598.939 2563.03 599.547 2564.05L599.732 2563.97C599.611 2562.77 599.914 2561.65 600.641 2560.61C601.364 2559.56 602.387 2558.79 603.708 2558.27C605.415 2557.61 607.011 2557.62 608.494 2558.31C609.986 2558.99 611.085 2560.25 611.792 2562.07L616.446 2574.08L610.049 2576.56L606.024 2566.17C605.721 2565.39 605.288 2564.86 604.723 2564.57C604.155 2564.28 603.539 2564.26 602.875 2564.51C602.218 2564.77 601.784 2565.2 601.571 2565.79C601.363 2566.38 601.41 2567.06 601.713 2567.84L605.738 2578.23L599.62 2580.6L595.594 2570.22C595.292 2569.44 594.858 2568.9 594.293 2568.61C593.726 2568.32 593.11 2568.3 592.445 2568.56C592.005 2568.73 591.665 2568.98 591.426 2569.3C591.187 2569.62 591.052 2570.01 591.022 2570.46C590.995 2570.89 591.083 2571.37 591.283 2571.89L595.309 2582.27L588.912 2584.75Z",
    fill: "white"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M622.189 2579.53L612.7 2555.05L619.051 2552.59L620.255 2555.7L620.394 2555.64C620.392 2554.95 620.518 2554.27 620.771 2553.59C621.022 2552.91 621.421 2552.29 621.968 2551.73C622.513 2551.16 623.226 2550.71 624.106 2550.36C625.281 2549.91 626.518 2549.79 627.819 2550.01C629.128 2550.22 630.375 2550.87 631.561 2551.95C632.754 2553.04 633.767 2554.65 634.6 2556.8C635.397 2558.86 635.736 2560.68 635.619 2562.28C635.51 2563.88 635.051 2565.22 634.242 2566.3C633.442 2567.37 632.408 2568.16 631.141 2568.65C630.306 2568.97 629.508 2569.12 628.747 2569.11C627.99 2569.08 627.289 2568.92 626.642 2568.63C626.001 2568.33 625.44 2567.92 624.959 2567.42L624.866 2567.45L628.586 2577.05L622.189 2579.53ZM622.409 2561.53C622.744 2562.39 623.147 2563.1 623.616 2563.65C624.091 2564.18 624.604 2564.54 625.156 2564.73C625.713 2564.9 626.285 2564.88 626.872 2564.65C627.459 2564.42 627.893 2564.06 628.173 2563.57C628.459 2563.07 628.588 2562.46 628.562 2561.75C628.54 2561.03 628.359 2560.23 628.018 2559.35C627.676 2558.47 627.272 2557.76 626.805 2557.22C626.343 2556.67 625.84 2556.31 625.294 2556.14C624.752 2555.96 624.188 2555.99 623.601 2556.21C623.014 2556.44 622.574 2556.81 622.281 2557.31C621.992 2557.81 621.855 2558.41 621.869 2559.14C621.887 2559.85 622.067 2560.65 622.409 2561.53Z",
    fill: "white"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M637.926 2538.45L647.127 2562.18L640.73 2564.66L631.529 2540.93L637.926 2538.45Z",
    fill: "white"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M659.088 2557.92C657.156 2558.67 655.355 2558.93 653.683 2558.69C652.008 2558.45 650.537 2557.79 649.27 2556.7C648 2555.6 647.012 2554.14 646.305 2552.32C645.598 2550.49 645.345 2548.75 645.546 2547.09C645.744 2545.42 646.382 2543.94 647.46 2542.64C648.536 2541.34 650.04 2540.31 651.971 2539.56C653.903 2538.81 655.706 2538.56 657.38 2538.8C659.052 2539.03 660.523 2539.69 661.793 2540.79C663.06 2541.88 664.047 2543.34 664.754 2545.16C665.461 2546.99 665.715 2548.73 665.517 2550.4C665.317 2552.06 664.678 2553.54 663.603 2554.85C662.524 2556.15 661.019 2557.17 659.088 2557.92ZM657.301 2553.17C657.842 2552.96 658.239 2552.6 658.492 2552.08C658.745 2551.57 658.85 2550.93 658.805 2550.18C658.761 2549.42 658.559 2548.58 658.2 2547.65C657.838 2546.72 657.419 2545.96 656.945 2545.38C656.469 2544.79 655.963 2544.39 655.428 2544.18C654.893 2543.97 654.355 2543.97 653.815 2544.18C653.243 2544.4 652.823 2544.77 652.554 2545.29C652.285 2545.82 652.173 2546.46 652.217 2547.21C652.259 2547.96 652.46 2548.8 652.823 2549.74C653.182 2550.66 653.6 2551.42 654.077 2552.01C654.554 2552.6 655.068 2552.99 655.618 2553.2C656.168 2553.4 656.729 2553.39 657.301 2553.17Z",
    fill: "white"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M676.722 2558.39C675.988 2558.67 675.266 2558.88 674.557 2559.03C673.851 2559.18 673.209 2559.25 672.632 2559.25L672.261 2554.17C672.859 2554.15 673.384 2554.09 673.838 2553.97C674.299 2553.86 674.662 2553.68 674.926 2553.44C675.198 2553.21 675.34 2552.9 675.353 2552.52L675.367 2552.14L661.903 2535.98L668.578 2533.39L676.232 2544.61L676.417 2544.53L674.557 2531.07L681.279 2528.47L682.265 2550.27C682.321 2551.37 682.191 2552.44 681.876 2553.46C681.571 2554.48 681.008 2555.41 680.188 2556.26C679.369 2557.1 678.213 2557.81 676.722 2558.39Z",
    fill: "white"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M698.112 2542.79C696.212 2543.53 694.433 2543.8 692.776 2543.6C691.124 2543.4 689.662 2542.76 688.391 2541.68C687.123 2540.59 686.119 2539.09 685.376 2537.17C684.663 2535.33 684.411 2533.58 684.619 2531.92C684.828 2530.25 685.46 2528.78 686.515 2527.49C687.571 2526.2 689.018 2525.2 690.857 2524.49C692.201 2523.97 693.498 2523.7 694.75 2523.7C696.001 2523.69 697.167 2523.94 698.248 2524.43C699.326 2524.92 700.292 2525.65 701.147 2526.62C702.001 2527.58 702.702 2528.77 703.25 2530.19L703.826 2531.67L687.926 2537.83L686.56 2534.31L696.573 2530.43C696.367 2529.92 696.062 2529.52 695.658 2529.24C695.258 2528.94 694.803 2528.76 694.294 2528.71C693.79 2528.65 693.272 2528.72 692.739 2528.93C692.221 2529.13 691.789 2529.43 691.444 2529.82C691.095 2530.2 690.864 2530.64 690.751 2531.13C690.646 2531.61 690.686 2532.12 690.871 2532.64L692.345 2536.44C692.566 2537.01 692.884 2537.48 693.297 2537.83C693.71 2538.19 694.19 2538.4 694.737 2538.49C695.284 2538.57 695.874 2538.48 696.508 2538.24C696.948 2538.07 697.326 2537.85 697.641 2537.59C697.964 2537.32 698.212 2537.02 698.385 2536.68C698.555 2536.34 698.637 2535.98 698.632 2535.6L704.473 2533.34C704.751 2534.65 704.692 2535.91 704.296 2537.11C703.897 2538.31 703.177 2539.39 702.136 2540.38C701.099 2541.35 699.758 2542.15 698.112 2542.79Z",
    fill: "white"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M717.966 2535.09C716.066 2535.83 714.287 2536.1 712.63 2535.91C710.978 2535.7 709.516 2535.06 708.245 2533.98C706.978 2532.89 705.973 2531.39 705.23 2529.47C704.517 2527.63 704.265 2525.88 704.473 2524.22C704.682 2522.56 705.314 2521.08 706.369 2519.79C707.425 2518.5 708.872 2517.5 710.711 2516.79C712.055 2516.27 713.353 2516.01 714.604 2516C715.855 2515.99 717.021 2516.24 718.102 2516.74C719.18 2517.23 720.146 2517.95 721.001 2518.92C721.855 2519.89 722.556 2521.08 723.105 2522.49L723.68 2523.97L707.78 2530.14L706.414 2526.61L716.427 2522.73C716.221 2522.22 715.916 2521.83 715.512 2521.54C715.112 2521.24 714.657 2521.07 714.149 2521.02C713.645 2520.95 713.126 2521.03 712.593 2521.23C712.075 2521.43 711.644 2521.73 711.298 2522.12C710.949 2522.5 710.718 2522.94 710.605 2523.43C710.5 2523.91 710.54 2524.42 710.725 2524.94L712.199 2528.74C712.421 2529.31 712.738 2529.78 713.151 2530.13C713.564 2530.49 714.044 2530.71 714.591 2530.79C715.138 2530.87 715.729 2530.79 716.362 2530.54C716.802 2530.37 717.18 2530.15 717.495 2529.89C717.818 2529.62 718.066 2529.32 718.239 2528.99C718.409 2528.65 718.491 2528.29 718.486 2527.91L724.327 2525.64C724.605 2526.95 724.546 2528.21 724.15 2529.42C723.751 2530.61 723.031 2531.7 721.99 2532.68C720.953 2533.65 719.612 2534.45 717.966 2535.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotA);
export default __webpack_public_path__ + "static/media/LotA.c9c908d5302ad877c2f7ebcf23f7a907.svg";
export { ForwardRef as ReactComponent };